import { MultiCourseCompetitionService } from 'services/multi-course-competition-service/multi-course-competition.service';
import { AppCustomizerService } from 'src/providers/app-customizer-service/app-customizer.service';
import { CommonPullupMenuComponent } from 'src/app/pages/modal-screens/common-pullup-menu/common-pullup-menu.component';
// import { TermsAndConditionComponent } from './terms-and-condition/terms-and-condition.component';
import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { PackageService } from 'src/providers/package-service/package-service';
import {
  getPackageRequestData,
  Item,
  PackageRequest,
  StayRequest,
  PlayRequest,
  StayOption,
} from 'src/data/package-data';
import {
  AlertController,
  Platform,
  LoadingController,
  ModalController,
  ToastController,
  IonSlides,
  IonContent,
} from '@ionic/angular';
import { filter, map } from 'rxjs/operators';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NavController } from '@ionic/angular';
import * as _ from 'underscore';
import * as moment from 'moment';
import { PaymentService } from 'src/providers/payment-service/payment-service';
// import { PackagePlayOption, PackageStayOption, PaymentGatewayInfo, PlayerHomeInfo, StayAndPlayCourse, StayAndPlayPackage, StayAndPlayRequest } from 'src/data/mygolf.data';
import { InAppBrowser, InAppBrowserOptions } from '@awesome-cordova-plugins/in-app-browser/ngx';
import {
  GameChargeDetails,
  PackagePlayOption,
  PackageStayOption,
  PackageSurchargeApplied,
  PaymentGatewayInfo,
  PlayerHomeInfo,
  RefundInstance,
  RoomChargeDetails,
  StayAndPlayAdjustment,
  StayAndPlayCharge,
  StayAndPlayCourse,
  StayAndPlayPackage,
  StayAndPlayPayment,
  StayAndPlayRequest,
} from 'src/data/mygolf.data';
// import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';
import { sha256 } from 'js-sha256';
import * as global from 'src/globals';
// import { HotelSelectionModalComponent } from './hotel-selection-modal/hotel-selection-modal.component';
import { Ipay88Details } from '../booking/caddy-flight-details/caddy-flight-details.page';
import { firstValueFrom, Observable } from 'rxjs';
import { DateRangePicker } from 'src/app/shared/date-range-picker.component';
import { PlayerHomeDataService } from 'src/redux/player-home';
import { JsonService } from 'src/json-util';
import { isPresent } from 'src/providers/common-service';
// import { packageMoreInfo } from './package-more-Info.page';
// import { packageChat } from './package-chat/package-chat.page';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { Socket, io } from 'socket.io-client';
// import { RoomModalComponent } from './room-modal/room-modal.component';
import { CalendarComponentOptions } from 'ion2-calendar';
// import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
// import { StayOptionDetailComponent } from './stay-option-detail/stay-option-detail.component';
// import { PlayOptionDetailComponent } from './play-option-detail/play-option-detail.component';
// import { PackageBookingComponent } from './package-booking/package-booking.component';
import * as appProps from 'src/appProperties';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { add } from 'node_modules_cached/ionicons/icons';
import { PaymentSelectionPage } from '../booking/booking-details/payment-selection/payment-selection.page';
import {
  CommonPaymentSelectionPage,
  PageBillDetails,
  PaymentDetails,
} from '../modal-screens/common-payment-selection/common-payment-selection.page';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { HotelDetailsComponent } from '../hotel-details/hotel-details.component';

@Component({
  selector: 'app-hotel-list',
  templateUrl: './hotel-list.page.html',
  styleUrls: ['./hotel-list.page.scss'],
})
export class HotelListPage implements OnInit {
  socket: Socket;
  packageNearByInfoList: any = [];
  slideOpts = {
    slidesPerView: 1,
    speed: 400,
    spaceBetween: 0,
  };
  isShowInfo: boolean = false;
  isLocationInfo: boolean = false;
  dataExtras: any;
  packageId: number = 0;
  requestId: number = 0;
  packageDetails: Item & StayAndPlayPackage;
  requestDetails: getPackageRequestData & StayAndPlayRequest;
  playOptions = [];
  stayOptions = [];
  selectedPlayOptions: any;
  selectedStayOption: StayOption;
  nearByInfo: any = [];
  packageRequest = {} as PackageRequest;
  imageSrc = '';
  navigationExtras: NavigationExtras = {};
  isFromMyBookingPage: boolean = false;
  stayOptionsRequest = {} as StayRequest;
  playOptionsRequest = {} as PlayRequest;
  prefferedDate: any;
  selectedDates: any;
  prefferedEndDate: any;
  refresherBill: boolean = false;
  packageBookingBill: any;
  billDisplay: boolean = false;
  paymentGatewayList: Array<PaymentGatewayInfo>;
  makePayment: boolean = false;
  paymentRedirectUrl: string = '';
  paymentRedirectURL: string = '';
  selectPaymentMethod: any;
  paymentBackendURL: string;
  goToPaymentURL: string;
  paymentInternalURL: string;
  options: InAppBrowserOptions = {
    location: 'yes', //Or 'no'
    hidden: 'no', //Or  'yes'
    clearcache: 'yes',
    clearsessioncache: 'yes',
    zoom: 'yes', //Android only ,shows browser zoom controls
    hardwareback: 'yes',
    mediaPlaybackRequiresUserAction: 'no',
    shouldPauseOnSuspend: 'no', //Android only
    closebuttoncaption: 'Close', //iOS only
    disallowoverscroll: 'no', //iOS only
    toolbar: 'yes', //iOS only
    enableViewportScale: 'no', //iOS only
    allowInlineMediaPlayback: 'no', //iOS only
    presentationstyle: 'pagesheet', //iOS only
    fullscreen: 'yes', //Windows only
  };
  packageList: any[] = [];
  billData: any;
  localBill: number;
  paymentPageURL: string;
  private ipay88Details: any; // Ipay88Details;
  pgDescription: string;
  paymentSignAlgo: string;
  description: string;
  userDetailsForm: UntypedFormGroup;
  playerInfo: any;
  public playerHomeInfo$: Observable<PlayerHomeInfo>;
  mainImageSrc = [];
  imageIndex = [];
  isShowStayOption: boolean = false;
  roomName: any;
  standardOption: any;
  packageStayOptionsList: any = [];
  grpStayOption: boolean = true;
  grpPlayOption: boolean = false;
  grpNearByInfo: boolean = false;
  yourRequest: boolean = false;
  stayNight: number = 0;
  activeSegment: string = 'basicInfo';
  isBasicInfo: boolean = true;
  isStayOption: boolean = false;
  selectedHotelName: string = '';
  groupedOptions = [];
  selectedHotels: any = [];
  selectedHotelsRooms: any = [];
  selectedAdditionalNight = [];
  isPartnerNewMessages: boolean;
  clubCourseInfo = [];
  dayWiseSelectedClub = [];
  additionalPeople: number[] = new Array(this.selectedAdditionalNight.length).fill('');
  additionalPlayer: number[] = new Array(this.selectedHotels.length).fill(0);
  sharingRoom: number[] = new Array(this.selectedHotels.length).fill(false);
  rooms: number[] = [];
  additionalRooms: number[] = [];
  addNightSharingRoom: number[] = new Array(this.selectedHotels.length).fill(false);
  estimatedCharge: number = 0;
  selectedAdditionalDates: string[] = new Array(this.selectedAdditionalNight.length).fill('');
  isAvailableAdditionalNight: boolean = false;
  comments: string;
  submitConfirm: boolean = false;
  zoomActive = false;
  sliderZoomOpts = {
    allowSlidePrev: false,
    allowSlideNext: false,
    zoom: {
      maxRatio: 5,
    },
    on: {
      zoomChange: (scale, imageEl, slideEl) => {
        this.zoomActive = true;
        this.changeDetectorRef.detectChanges();
      },
    },
  };
  previousPage: string = '';
  packageForStayOptions: any;
  packageForPlayOptions: any;
  iab: any;
  enableRequest: string = '';
  @Input() newPackage: boolean = true;
  playOptionSegment: string = 'requested'; // request || info
  billsTrxnTabs: string = 'bills';
  @Input() hotelList: any[];
  @Input() headerTitle: string;

  constructor(
    private navCtrl: NavController,
    private router: Router,
    private paymentService: PaymentService,
    private platform: Platform,
    private loadingCtrl: LoadingController,
    // private iab: InAppBrowser,
    private modalCtrl: ModalController,
    private packageService: PackageService,
    private alertCtl: AlertController,
    private fb: UntypedFormBuilder,
    private playerHomeService: PlayerHomeDataService,
    private changeDetectorRef: ChangeDetectorRef,
    private toastCtl: ToastController,
    private activeRoute: ActivatedRoute,
    private datePipe: DatePipe,
    private mg2uUtils: mygolfUtils,
    private flightService: ClubFlightService,
    private customizerService: AppCustomizerService,
    private multiCourseCompService: MultiCourseCompetitionService
  ) {
    this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();

    this.playerHomeInfo$
      .pipe(
        filter(Boolean),
        map((playerHome: PlayerHomeInfo) => playerHome.player)
      )
      .subscribe(res => {
        this.playerInfo = res;
      });

    this.dataExtras = this.router.getCurrentNavigation()?.extras;
    // Get package Id
    this.packageId = !!this.dataExtras?.state?.packageId ? this.dataExtras?.state?.packageId : 0;
    if (!this.packageId) {
      this.packageId = this.router.getCurrentNavigation()?.extras?.state?.state?.packageId;
    }
    // If redirect from booking page than fetch request Id
    this.requestId = !!this.dataExtras?.state?.requestId
      ? this.dataExtras.state.requestId
      : !!this.dataExtras?.state?.state?.requestId
        ? this.dataExtras?.state?.state?.requestId
        : 0;

    this.isFromMyBookingPage = !!this.dataExtras?.state?.isFromMyBookingPage
      ? this.dataExtras.state.isFromMyBookingPage
      : !!this.dataExtras?.state?.state?.isFromMyBookingPage
        ? this.dataExtras?.state?.state?.isFromMyBookingPage
        : false;

    this.billDisplay = this.dataExtras?.state?.state?.billDisplay || false;

    console.debug('active route : previousPage [0]', this.previousPage, this.dataExtras);
    if (this.previousPage?.length === 0) {
      this.previousPage = this.dataExtras?.state?.state?.previousPage;
    }
    console.debug('active route : previousPage [1]', this.previousPage, this.dataExtras);

    console.debug('init package details', this.dataExtras);
    this.newPackage = this.dataExtras?.state?.state?.newPackage ? true : false;
    this.enableRequest = this.platform.getQueryParam('enableStayNPlayRequest');
    console.debug(
      'enable stay play request : ',
      this.enableRequest,
      this.platform.getQueryParam('enableStayNPlayRequest')
    );
    this.multiCourseCompService.getSelectedHotelRoom().subscribe(hotelRoom => {
      console.debug('from hotel list page : ', hotelRoom);
      // if (hotelRoom?.room) {
      //   this.modalCtrl.dismiss();
      // }
    });
  }

  async ngOnInit() {
    console.debug('init hotel list page : ', this.hotelList);
    // if (!this.packageId) {
    //   this.customizerService.goToPlayerHome();
    //   // this.router.navigate(['package-booking'], { replaceUrl: false });
    //   return;
    // }
    // this.defineUserDetailsForm();
    // await this.getPackageDetails();
    console.debug('on init : ', this.packageList, this.packageDetails, this.requestDetails);
    if (appProps.enableChat) this.socketConnection();
  }

  defineUserDetailsForm() {
    this.userDetailsForm = this.fb.group({
      requesterName: [this.playerInfo?.userProfile?.name ?? '', Validators.required],
      requesterEmail: [this.playerInfo?.email ?? '', [Validators.required, Validators.email]],
      phoneNumber: [this.playerInfo?.userProfile?.phoneNumber ?? '', Validators.required],
      totalPax: [0, [Validators.required, Validators.min(1)]],
      preferredDates: ['', Validators.required],
    });
  }

  async presentModal(packageDetails: any) {
    // const modal = await this.modalCtrl.create({
    //   component: packageMoreInfo,
    //   cssClass: this.platform.is('mobile')
    //     ? 'self-adjustable-modal'
    //     : 'self-adjustable-modal-desktop',
    //   componentProps: {
    //     packageDetails: packageDetails,
    //     isFromMyBookingPage: this.isFromMyBookingPage,
    //     requestDetails: this.requestDetails,
    //   },
    // });
    // return await modal.present();
  }
  async chatModal() {
    // let _phoneNumber = '60126908309';
    // if (this.packageDetails?.club) {
    //   if (this.packageDetails?.club?.address) {
    //     _phoneNumber =
    //       this.packageDetails?.club?.address?.phone2 ||
    //       this.packageDetails?.club?.address?.phone1 ||
    //       _phoneNumber;
    //     // this.packageDetails?.club?.address?.phoneNumbers[1] ||
    //   }
    // } else if (this.packageDetails?.partner) {
    //   if (this.packageDetails?.partner?.address)
    //     _phoneNumber =
    //       this.packageDetails?.partner?.address?.phone2 ||
    //       this.packageDetails?.partner?.address?.phone1 ||
    //       _phoneNumber;
    // }
    // if (1) {
    //   let _url = `https://api.whatsapp.com/send?phone=${_phoneNumber}&text=`;
    //   let _text = 'Hello, I am interested in package ' + this.packageDetails?.packageName;
    //   window.open(_url + _text, '_system');
    //   return;
    // }
    // let _enableRequest = this.enableRequest;
    // let _msg = 'This feature will be coming soon';
    // _msg = 'If interested, please contact us at +6012-690 8309';
    // if (
    //   !appProps?.enableStayNPlayRequest &&
    //   (_enableRequest === null ||
    //     _enableRequest === undefined ||
    //     _enableRequest === '' ||
    //     _enableRequest === 'false')
    // ) {
    //   MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 5000, 'bottom');
    //   return;
    // }
    // const modal = await this.modalCtrl.create({
    //   component: packageChat,
    //   cssClass: 'package-chat-popup',
    //   swipeToClose: true,
    //   componentProps: {
    //     packageDetails: this.packageDetails,
    //     requestId: this.requestDetails?.id,
    //   },
    // });
    // await modal.present();
    // await modal.onDidDismiss().then(data => {
    //   this.socket.emit('getChannel', {
    //     packageId: this.packageId,
    //     userId: data?.data,
    //     requestId: this.requestDetails?.id,
    //   });
    // });
  }

  // Get package details by packageId and requestId based of reuqest from Booking page or not
  async getPackageDetails() {
    let loader: any = await this.loadingCtrl.create({
      showBackdrop: true,
    });

    await loader.present().then(async () => {
      await firstValueFrom(this.packageService.getPackageById(this.packageId))
        .then((resp: Item & StayAndPlayPackage) => {
          this.packageDetails = resp;
          this.setGroupedPlayOptions();
          this.setGroupedStayOptions();
          // Stay Option
          if (this.packageDetails?.packageStayOptions.length > 0) {
            this.packageForStayOptions = this.packageDetails?.packageStayOptions;
            this.grpStayOption = true;
          }
          // Play Option
          if (this.packageDetails?.packagePlayOptions.length > 0) {
            this.packageForPlayOptions = this.packageDetails?.packagePlayOptions;
            this.grpPlayOption = true;
          }
          if (
            !!this.packageDetails?.packagePlayOptions &&
            this.packageDetails?.packagePlayOptions?.length > 0
          ) {
            for (let i = 0; i < this.packageDetails?.packagePlayOptions?.length; i++) {
              if (!!this.packageDetails?.packagePlayOptions[i]?.club?.clubImage) {
                JsonService.deriveFullUrl(
                  this.packageDetails?.packagePlayOptions[i]?.club,
                  'clubImage'
                );
              }
            }
          }
          const map = new Map();
          this.packageDetails.packageStayOptions.forEach(option => {
            const hotelName = option.hotel.name;

            if (!map.has(hotelName)) {
              map.set(hotelName, []);
            }

            map.get(hotelName).push(option);
          });

          map.forEach(options => {
            this.groupedOptions.push(options);
          });

          const mappingData = new Map();
          this.packageDetails.packagePlayOptions.forEach(element => {
            const clubName = element.club.name;
            if (!mappingData.has(clubName)) {
              mappingData.set(clubName, []);
            }
            mappingData.get(clubName).push(element);
          });
          mappingData.forEach(options => {
            this.clubCourseInfo.push(options);
          });

          // Output

          for (let i = 0; i < this.packageDetails?.packageStayOptions?.length; i++) {
            this.isShowStayOption = this.packageDetails?.packageStayOptions[i].defaultOption;
            if (this.isShowStayOption) {
              this.selectedStayOption = this.packageDetails?.packageStayOptions[i];
              this.packageStayOptionsList.push(this.packageDetails?.packageStayOptions[i]);
              for (let i = 0; i < this.packageStayOptionsList.length; i++) {
                if (!!this.packageStayOptionsList[i]?.hotel) {
                  if (isPresent(this.packageStayOptionsList[i]?.hotel?.hotelLogo)) {
                    JsonService.deriveFullUrl(this.packageStayOptionsList[i]?.hotel, 'hotelLogo');
                  }
                }
              }
              break;
            }
          }
          if (resp?.packageImages) {
            this.packageList.push(resp);
            for (let i = 0; i < this.packageList.length; i++) {
              this.mainImageSrc[i] = this.packageList[i].packageImages[0];
              this.imageIndex[i] = 1;
            }
          } else {
            this.packageList = [];
          }
          this.nearByInfo = resp.nearbyAttractions;
          this.packageNearByInfoList = resp.nearbyAttractions;
          for (let i = 0; i < this.packageNearByInfoList.length; i++) {
            if (!!this.packageNearByInfoList[i]?.images) {
              JsonService.deriveFullImageUrlArrayObject(this.packageNearByInfoList[i]?.images);
            }
          }
          this.imageSrc =
            this.packageDetails?.packageImages != null
              ? global.MygolfServer + '/' + this.packageDetails?.packageImages[0]
              : '';
          if (!this.isFromMyBookingPage) loader.dismiss();
        })
        .catch(() => {
          loader.dismiss();
        });
      if (this.isFromMyBookingPage) {
        await firstValueFrom(this.packageService.getPackageRequestData(this.requestId))
          .then(async (resp: any) => {
            this.requestDetails = resp;
            this.billAdjustmentItems = this.constructBillAdjItems();
            this.surchargesAppliedItems = this.constructSurchargeAppliedItems();
            this.sortRequestDetails();
            await this.setEffectiveDays(
              resp?.stayPlayPackage?.stayDuration?.effectiveDays,
              this.requestDetails.startDate
            );
            if (this.requestDetails) {
              await this.constructGroupedPlayOptions();
            }

            if (this.dayWiseSelectedClub) {
              await this.dayWiseSelectedClub.forEach(day => {
                // mergedPlayOptions.push(...this.objectValues(this.groupAndMergePlayOptions(this.getDayGames(day.date))));
                this.mergedDayPlayOptions.push(
                  this.objectValues(this.groupAndMergePlayOptions(this.getDayGames(day.date)))
                );
                // console.debug(`${day.day} ${day.date} grouped play options`, mergedPlayOptions);
              });
            }

            // bind basic info form
            this.bindBasicInfo(this.requestDetails);

            //  bind stay option form
            this.selectedHotels = [];
            this.bindStayOption(this.requestDetails.requestRooms);
            this.isAvailableAdditionalNight = this.selectedHotels.some(
              hotel => hotel.availableForAdditionalNight
            );

            // enable segment buttons
            this.estimatedCharge = this.requestDetails.chargeDetails.netCharge;
            this.comments = this.requestDetails?.specialInstructions;
            this.grpPlayOption = true;
            this.submitConfirm = true;
            this.isStayOption = true;

            // bind play option
            this.bindPlayOption(this.requestDetails.requestGames);
            loader.dismiss();
          })
          .catch(() => {
            loader.dismiss();
          });
      }
    });
  }

  bindBasicInfo(basicInfo: any) {
    this.prefferedDate = {
      from: moment(basicInfo.startDate, 'YYYY-MM-DD').startOf('day').toDate(),
      to: moment(basicInfo.endDate, 'YYYY-MM-DD').startOf('day').toDate(),
    };
    this.setDateInput({
      from: this.prefferedDate.from,
      to: this.prefferedDate.to,
    });

    // bind basic information of user
    this.userDetailsForm.patchValue({
      requesterEmail: basicInfo.requesterEmail,
      requesterName: basicInfo.requesterName,
      phoneNumber: basicInfo.phoneNumber,
      totalPax: basicInfo.noOfPax,
    });
  }

  bindPlayOption(playOption: Array<any>) {
    // group same date play option in one array
    if (playOption.length) {
      const grouped = playOption.reduce((acc, game) => {
        const key = game?.playingOn;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(game);
        return acc;
      }, {});

      Object.keys(grouped).map((key, index) => {
        const ids = [];
        grouped[key].map(k => ids.push(k?.id));
        const indx = this.dayWiseSelectedClub.findIndex(day => day.date === key);

        this.dayWiseSelectedClub[indx].clubName = grouped[key][0]?.playOption?.club?.name;
        this.dayWiseSelectedClub[indx].courseName = grouped[key][0].playOption?.course?.name;
        this.dayWiseSelectedClub[indx].requestGameId = ids.toString();
        // this.dayWiseSelectedClub[index].selectedClub = play.playOption;
      });
    }
  }

  setEffectiveDays(effectiveDays, startDate) {
    // add days according to effectiveDays
    for (let i = 0; i < effectiveDays; i++) {
      this.dayWiseSelectedClub.push({
        ...this.dayWiseSelectedClub[i],
        day: i + 1,
        date: moment(moment(startDate, 'YYYY-MM-DD').add(i, 'day').startOf('day').toDate()).format(
          'YYYY-MM-DD'
        ),
      });
    }
  }

  bindStayOption(stayOption: Array<any>) {
    let normalIndex = 0;
    let addNightIndex = 0;

    stayOption.map(room => {
      // update additional night room data
      if (room.additionalNights) {
        const stayOption = JSON.parse(JSON.stringify(room.stayOption));
        stayOption.requestRoomId = room.id;
        this.selectedAdditionalNight.push(stayOption);
        this.addNightSharingRoom[addNightIndex] = room.sharing;
        this.additionalPeople[addNightIndex] = room.numberOfGuests;
        this.selectedAdditionalDates[addNightIndex] = moment(
          room.additionalNightsStartDate,
          'YYYY-MM-DD'
        ).format('DD-MM-YYYY');
        addNightIndex += 1;
      } else {
        // update normal and additional room data
        const stayOption = JSON.parse(JSON.stringify(room.stayOption));
        stayOption.requestRoomId = room.id;
        this.selectedHotels.push(stayOption);
        this.sharingRoom[normalIndex] = room.sharing;
        this.additionalPlayer[normalIndex] = room.numberOfGuests;
        normalIndex += 1;
      }

      // check availability of additional night in selected room
      this.isAvailableAdditionalNight = this.selectedHotels.some(
        hotel => hotel.availableForAdditionalNight
      );
    });
  }

  onNextClick(type: string) {
    switch (type) {
      case 'basicInfo':
        if (this.userDetailsForm.valid) {
          const startDate = moment(
            this.userDetailsForm.value.preferredDates.split('-')[0],
            'M/DD/YYYY'
          ).format('YYYY-MM-DD');
          if (!this.requestDetails)
            this.setEffectiveDays(this.packageDetails?.stayDuration?.effectiveDays, startDate);
          if (this.requestDetails) {
            // set payload
            const requesterData = JSON.parse(localStorage.getItem('mygolf2uapp.sessionInfo'));
            const endDate = moment(
              this.userDetailsForm.value.preferredDates.split('-')[1],
              'M/DD/YYYY'
            ).format('YYYY-MM-DD');
            const startDate = moment(
              this.userDetailsForm.value.preferredDates.split('-')[0],
              'M/DD/YYYY'
            ).format('YYYY-MM-DD');
            const payload = {
              ...this.userDetailsForm.value,
              requestId: this.requestDetails.id,
              specialInstructions: this.comments,
              startDate: startDate,
              endDate: endDate,
              playerId: requesterData?.playerId,
            };
            /**
             * Call api to update player basic information.
             * Note:- you can only change start date and end date.
             */
            this.packageService.updateRequest(payload).subscribe({
              next: (data: any) => {
                this.bindBasicInfo(data);
                this.isStayOption = true;
                this.activeSegment = 'stayOption';
                this.isBasicInfo = false;
              },
              error: err => {
                this.errorMessage(err as string);
              },
            });
          } else {
            this.isStayOption = true;
            this.activeSegment = 'stayOption';
            this.isBasicInfo = false;
          }
        }
        break;
      case 'stayOption':
        if (this.selectedHotels !== null || this.selectedHotelsRooms.length !== 0) {
          // If user add new rooms while review the request
          const newNormalRooms = this.selectedHotels?.filter(hotel => !hotel?.requestRoomId);
          const isSameLength = newNormalRooms?.length === this.selectedHotels?.length;
          const newAddNightRooms = this.selectedAdditionalNight?.filter(
            hotel => !hotel?.requestRoomId
          );
          const isSameAddLength = newAddNightRooms?.length === this.selectedAdditionalNight?.length;
          if (this.requestDetails) {
            const payload = [];
            // add normal room data
            if (newNormalRooms?.length) {
              let normalIndex = this.selectedHotels?.length - 1;
              newNormalRooms.map((room, index) => {
                payload.push({
                  requestId: this.requestDetails.id,
                  stayOption: room.id,
                  nights: 0,
                  sharing: this.sharingRoom[isSameLength ? index : normalIndex + index],
                  numberOfGuests: this.additionalPlayer[isSameLength ? index : normalIndex + index],
                });
              });
            }
            // add additional night room data
            if (newAddNightRooms?.length) {
              let addNightIndex = this.selectedAdditionalNight?.length - 1;
              newAddNightRooms.map((room, index) => {
                payload.push({
                  requestId: this.requestDetails.id,
                  stayOption: room.id,
                  nights: 0,
                  sharing:
                    this.addNightSharingRoom[isSameAddLength ? index : addNightIndex + index],
                  numberOfGuests:
                    this.additionalPeople[isSameAddLength ? index : addNightIndex + index],
                  additionalNights: true,
                  additionalNightStartDate: moment(
                    this.selectedAdditionalDates[isSameAddLength ? index : addNightIndex + index],
                    'DD-MM-YYYY'
                  ).format('YYYY-MM-DD'),
                });
              });
            }
            // call API when user add new room request
            if (payload?.length) {
              this.packageService.addRequestedRoom(payload, this.requestDetails?.id).subscribe({
                next: data => {
                  this.isBasicInfo = false;
                  this.activeSegment = 'playOption';
                  this.errorMessage('New room added successfully.');
                },
                error: err => {
                  this.errorMessage(err as string);
                },
              });
            } else {
              this.isBasicInfo = false;
              this.activeSegment = 'playOption';
            }

            this.updateRoomRequest();
          } else {
            this.isBasicInfo = false;
            this.activeSegment = 'playOption';
          }
        }
        break;
      case 'playOption':
        // If user add new game while review the request
        const newGameRequest = this.dayWiseSelectedClub?.filter(
          game => !game?.requestGameId && game?.selectedClub
        );
        const startDate = moment(
          this.userDetailsForm.value.preferredDates.split('-')[0],
          'M/DD/YYYY'
        ).format('YYYY-MM-DD');
        if (this.requestDetails) {
          const payload = [];
          if (newGameRequest?.length) {
            newGameRequest.map(club => {
              if (club?.selectedClub?.playIn === 'both') {
                // morning number of rounds to play
                payload.push({
                  requestId: this.requestDetails?.id,
                  playOption: club.selectedClub.id,
                  dateOfPlay: moment(startDate, 'YYYY-MM-DD')
                    .add(club?.day - 1, 'days')
                    .format('YYYY-MM-DD'),
                  playingIn: 'AM',
                  numberOfRounds: club.selectedClub.noOfRoundsAM,
                  additionalRound: club.selectedClub.availableForAdditionalRound,
                });
                // evening number of rounds to play
                payload.push({
                  requestId: this.requestDetails?.id,
                  playOption: club.selectedClub.id,
                  dateOfPlay: moment(startDate, 'YYYY-MM-DD')
                    .add(club?.day - 1, 'days')
                    .format('YYYY-MM-DD'),
                  playingIn: 'PM',
                  numberOfRounds: club.selectedClub.noOfRoundsPM,
                  additionalRound: club.selectedClub.availableForAdditionalRound,
                });
              } else {
                payload.push({
                  requestId: this.requestDetails?.id,
                  playOption: club.selectedClub.id,
                  dateOfPlay: moment(startDate, 'YYYY-MM-DD')
                    .add(club?.day - 1, 'days')
                    .format('YYYY-MM-DD'),
                  playingIn: club?.selectedClub?.playIn,
                  numberOfRounds: 0,
                  additionalRound: club.selectedClub.availableForAdditionalRound,
                });
              }
            });
            // if user added new play option then call API to save it
            if (payload?.length) {
              this.packageService.addRequestedGame(payload, this.requestDetails?.id).subscribe({
                next: data => {
                  this.bindPlayOption(data?.requestGames);
                  this.activeSegment = 'review';
                  this.errorMessage('New game added successfully.');
                },
                error: err => {
                  this.errorMessage(err as string);
                },
              });
            } else {
              this.activeSegment = 'review';
            }
          } else {
            this.activeSegment = 'review';
          }
        } else {
          this.activeSegment = 'review';
        }
        break;
      case 'review':
        this.activeSegment = 'submit';
        this.submitConfirm = true;
        break;
    }
    this.getEstimatedCharge();
  }

  getEstimatedCharge() {
    this.packageService.getEstimatedCharge(this.getPayload(), this.packageId).subscribe({
      next: (data: any) => {
        this.estimatedCharge = data.netCharge;
      },
      error: err => {
        this.errorMessage('Failed to get estimated charge.');
      },
    });
  }

  async addAnotherRoomType() {
    // if (this.selectedHotels?.length !== 0) {
    //   const modal = await this.modalCtrl.create({
    //     component: RoomModalComponent,
    //     componentProps: {
    //       stayOptions: this.groupedOptions,
    //       hotelId: this.selectedHotels[0].hotel?.id,
    //     },
    //     cssClass: 'custom-dropdown',
    //     backdropDismiss: true,
    //     showBackdrop: true,
    //   });
    //   await modal.present();
    //   await modal.onDidDismiss().then(data => {
    //     const selectedRoom = JSON.parse(JSON.stringify(data?.data?.selectedRoom));
    //     if (selectedRoom) {
    //       selectedRoom.requestRoomId = null;
    //       this.selectedHotels.push(selectedRoom);
    //       // return true if any hotel have additional night facility
    //       this.isAvailableAdditionalNight = this.selectedHotels.some(
    //         hotel => hotel.availableForAdditionalNight
    //       );
    //     }
    //   });
    // } else {
    //   this.errorMessage('Please select a stay option first.');
    // }
  }

  get isStayNextBtnDisable() {
    return (
      this.selectedHotels.length !== this.additionalPlayer.length ||
      this.selectedAdditionalNight.length !== this.additionalPeople.length ||
      this.selectedAdditionalNight.length !== this.selectedAdditionalDates.length ||
      this.additionalPlayer.some(player => !+player) ||
      this.additionalPeople.some(player => !+player)
    );
  }

  get isPlayNextBtnDisable() {
    return !this.dayWiseSelectedClub.some(day => day?.clubName);
  }

  errorMessage(message: string) {
    MessageDisplayUtil.showErrorToast(message, this.platform, this.toastCtl, 5000, 'bottom');
  }

  backRouting() {
    console.debug('active route on click back ', this.previousPage);
    if (this.previousPage === 'package-booking' || !this.newPackage) {
      this.navigationExtras.state = { bookings: 2 };
      this.router.navigate(['package-booking'], {
        replaceUrl: false,
        state: this.navigationExtras,
      });
    } else {
      this.router.navigate(['/tabs/player-home'], { replaceUrl: false });
    }
  }
  onInfoShow() {
    if (this.isShowInfo) {
      this.isShowInfo = false;
    } else {
      this.isShowInfo = true;
    }
  }
  onLocationShow(item) {
    this.description = item;
    if (this.isLocationInfo) {
      this.isLocationInfo = false;
    } else {
      this.isLocationInfo = true;
    }
  }

  getPayload() {
    const roomRequests = [];
    const gameRequests = [];
    const requesterData = JSON.parse(localStorage.getItem('mygolf2uapp.sessionInfo'));
    const endDate = moment(
      this.userDetailsForm.value.preferredDates.split('-')[1],
      'M/DD/YYYY'
    ).format('YYYY-MM-DD');
    const startDate = moment(
      this.userDetailsForm.value.preferredDates.split('-')[0],
      'M/DD/YYYY'
    ).format('YYYY-MM-DD');
    // stay option payload
    if (this.selectedAdditionalNight) {
      this.selectedAdditionalNight.map((room, index) => {
        roomRequests.push({
          stayOption: +room?.id,
          nights: 0,
          requestId: +room?.requestRoomId,
          sharing: this.addNightSharingRoom[index] || false,
          numberOfGuests: +this.additionalPeople[index],
          additionalNights: true,
          additionalNightStartDate: moment(
            this.selectedAdditionalDates[index],
            'DD-MM-YYYY'
          ).format('YYYY-MM-DD'),
        });
      });
    }

    if (this.selectedHotels) {
      this.selectedHotels.map((room, index) => {
        roomRequests.push({
          stayOption: +room?.id,
          nights: 0,
          requestId: +room?.requestRoomId,
          sharing: this.sharingRoom[index] || false,
          numberOfGuests: +this.additionalPlayer[index],
        });
      });
    }

    // play option payload
    this.dayWiseSelectedClub.map((club, index) => {
      if (club?.selectedClub) {
        if (club?.selectedClub?.playIn === 'both') {
          // morning number of rounds to play
          gameRequests.push({
            playOption: +club.selectedClub.id,
            dateOfPlay: moment(startDate, 'YYYY-MM-DD').add(index, 'days').format('YYYY-MM-DD'),
            playingIn: 'AM',
            requestId: +club?.requestGameId,
            numberOfRounds: +club.selectedClub.noOfRoundsAM,
            additionalRound: club.selectedClub.availableForAdditionalRound,
          });
          // evening number of rounds to play
          gameRequests.push({
            playOption: +club.selectedClub.id,
            dateOfPlay: moment(startDate, 'YYYY-MM-DD').add(index, 'days').format('YYYY-MM-DD'),
            playingIn: 'PM',
            requestId: +club?.requestGameId,
            numberOfRounds: +club.selectedClub.noOfRoundsPM,
            additionalRound: club.selectedClub.availableForAdditionalRound,
          });
        } else {
          gameRequests.push({
            playOption: +club.selectedClub.id,
            dateOfPlay: moment(startDate, 'YYYY-MM-DD').add(index, 'days').format('YYYY-MM-DD'),
            playingIn: club?.selectedClub?.playIn,
            numberOfRounds: 0,
            requestId: +club?.requestGameId,
            additionalRound: club.selectedClub.availableForAdditionalRound,
          });
        }
      }
    });

    return {
      ...this.userDetailsForm.value,
      specialInstructions: this.comments,
      startDate: startDate,
      endDate: endDate,
      playerId: requesterData?.playerId,
      register: false,
      gender: '',
      gameRequests: gameRequests,
      roomRequests: roomRequests,
    };
  }

  // Make request for package, stay option and play options
  RequestForPackage() {
    this.packageService.requestPackage(this.getPayload(), this.packageId).subscribe({
      next: data => {
        const payload = {
          userId: JSON.parse(localStorage.getItem('mygolf2uapp.sessionInfo'))?.userId,
          playerId: JSON.parse(localStorage.getItem('mygolf2uapp.sessionInfo'))?.playerId,
          partnerId:
            this.packageDetails.partner !== null
              ? this.packageDetails.partner.id
              : this.packageDetails.club.id,
          packageId: this.packageId,
          requestId: data?.id,
        };
        this.socket.emit('saveRequestId', payload);
        this.errorMessage('Package request created successfully.');
        this.navigationExtras.state = { bookings: 2 };
        this.router.navigate(['package-booking'], {
          replaceUrl: false,
          state: this.navigationExtras,
        });
      },
      error: error => {
        this.errorMessage(error.error);
      },
    });
  }

  // Accept the requested package booking request
  AcceptPackageRequest() {
    let _message =
      this.requestDetails.stayPlayPackage.packageName +
      `<br><br>

    Are you sure to accept package booking request` +
      `</b>.<br>`;

    let alert = this.alertCtl
      .create({
        header: 'Booking Confirmation',
        message: _message,
        cssClass: 'booking-alert',
        buttons: [
          {
            text: 'Reject',
            cssClass: 'alertButton',
            role: 'cancel',
            handler: () => {
              //
            },
          },
          {
            text: 'Accept',
            handler: () => {
              for (let i = 0; i < this.requestDetails.stayOptionsSelected.length; i++) {
                var deleteStayOptionRequest = {
                  packageId: this.packageId,
                  requestId: this.requestDetails.id,
                  sequenceId: this.requestDetails.stayOptionsSelected[i].sequence,
                };

                if (this.requestDetails.stayOptionsSelected[i].sequence > 0) {
                  this.packageService
                    .deleteStayOption(deleteStayOptionRequest)
                    .subscribe(reps => {});
                }
              }

              for (let i = 0; i < this.requestDetails.playOptionsSelected.length; i++) {
                var deletePlayOptionRequest = {
                  packageId: this.packageId,
                  requestId: this.requestDetails.id,
                  sequenceId: this.requestDetails.playOptionsSelected[i].sequence,
                };

                if (this.requestDetails.playOptionsSelected[i].sequence > 0) {
                  this.packageService
                    .deletePlayOption(deletePlayOptionRequest)
                    .subscribe(reps => {});
                }
              }

              var requesterData = JSON.parse(localStorage.getItem('mygolf2uapp.sessionInfo'));
              this.packageRequest.packageId = this.packageId;
              this.packageRequest.playerId = requesterData.playerId;
              this.packageRequest = {
                ...this.packageRequest,
                ...this.userDetailsForm.value,
              };
              this.packageRequest.preferredDates = this.prefferedDate
                .sort((a, b) => a.getTime() - b.getTime())
                .map((date: Date) => moment(new Date(date)).format('YYYY-MM-DD'))
                .join();

              if (this.isFromMyBookingPage) {
                this.packageService
                  .updateRequestPackage(this.packageRequest, this.requestId)
                  .subscribe(reps => {
                    this.stayOptionsRequest.packageId = this.packageId;
                    this.stayOptionsRequest.noOfNights = this.selectedStayOption?.stayNight;
                    this.stayOptionsRequest.priority = 1;
                    this.stayOptionsRequest.stayOptionId = this.selectedStayOption.id;
                    this.stayOptionsRequest.requestId = reps.id;

                    this.packageService
                      .requestStayOption(this.stayOptionsRequest)
                      .subscribe(res => {});

                    for (let i = 0; i < this.selectedPlayOptions; i++) {
                      this.playOptionsRequest.packageId = this.packageId;
                      this.playOptionsRequest.noOfRounds = this.selectedPlayOptions[i].maxRounds;
                      this.playOptionsRequest.priority = i + 1;
                      this.playOptionsRequest.playOptionId = this.selectedPlayOptions[i].id;
                      this.playOptionsRequest.requestId = reps.id;

                      this.packageService
                        .requestPlayOption(this.playOptionsRequest)
                        .subscribe(res => {});
                    }
                  });
              }

              //
              this.packageService
                .generateRequest(this.packageId, this.requestId)
                .subscribe(reps => {
                  let _message = `Thank you for booking with myGolf2u.<br>`;
                  if (reps != undefined && reps != null) {
                    let alert = this.alertCtl
                      .create({
                        header: 'Package Booking Request In Process',

                        message: _message,
                        buttons: [
                          {
                            text: 'Go to My Bookings',
                            handler: () => {
                              this.navigationExtras.state = {
                                bookings: 2,
                              };

                              this.router.navigate(['package-booking'], {
                                replaceUrl: false,
                                state: this.navigationExtras,
                              });
                            },
                          },
                        ],
                      })
                      .then(res => {
                        res.present();
                      });
                  }
                });
            },
          },
        ],
      })
      .then(res => {
        res.present();
      });
  }

  async DeletePackageRequest() {
    let _message =
      this.requestDetails.stayPlayPackage.packageName +
      `<br><br>

    Are you sure to cancel this booking?`;

    const modal = await this.modalCtrl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        mode: 'negative-confirmation',
        headerTitle: 'Cancel Booking',
        confirmMessage: _message,
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      if (document.getElementsByClassName('inner-content')[0])
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      if (data?.data) {
        this.goCancelBooking();
      }
    });
  }
  // Detele package request by requestId
  oldDeletePackageRequest() {
    let _message =
      this.requestDetails.stayPlayPackage.packageName +
      `<br><br>

    Are you sure to cancel this booking?`;

    let alert = this.alertCtl
      .create({
        cssClass: 'my-custom-alert-class delete-booking',
        header: 'Cancel Booking',
        message: _message,
        buttons: [
          {
            text: 'No',
            role: 'cancel',
            handler: () => {},
          },
          {
            text: 'Yes',
            cssClass: 'alert-button-confirm',
            handler: () => {
              this.goCancelBooking();
            },
          },
        ],
      })
      .then(res => {
        res.present();
      });
  }

  goCancelBooking() {
    this.packageService.deleteRequest(this.packageId, this.requestId).subscribe(reps => {
      let _message = `Your package request cancelled successfully.<br>`;
      if (reps != undefined && reps != null) {
        MessageDisplayUtil.showMessageToast(_message, this.platform, this.toastCtl, 3000, 'bottom');

        this.navigationExtras = {
          state: {
            bookings: 2,
            isPackageBooking: true,
          },
        };
        this.router.navigate(['package-booking'], {
          replaceUrl: false,
          state: this.navigationExtras,
        });
        // let alert = this.alertCtl
        //   .create({
        //     header: 'Succesfully Cancelled Booking',

        //     message: _message,
        //     buttons: [{
        //       text: 'OK',
        //     },
        //       // {
        //       //   text: 'Go to My Bookings',
        //       //   handler: () => {

        //       //       this.navigationExtras = {
        //       //         state: {
        //       //           bookings: 2,
        //       //           isPackageBooking: true,
        //       //         },
        //       //       };
        //       //       this.router.navigate(['package-booking'], {
        //       //         replaceUrl: false,
        //       //         state: this.navigationExtras,
        //       //       });
        //       //     // let _navigationExtras = {
        //       //     //   // replaceUrl: false,
        //       //     //   state: {
        //       //     //     bookings: 2,
        //       //     //     needRefresh: true
        //       //     //   }
        //       //     // };
        //       //     // this.router.navigate(['package-booking'],{
        //       //     //   state: _navigationExtras
        //       //     // });
        //       //   },
        //       // },
        //     ],
        //   })
        //   .then((res) => {
        //     this.navigationExtras = {
        //       state: {
        //         bookings: 2,
        //         isPackageBooking: true,
        //       },
        //     };
        //     this.router.navigate(['package-booking'], {
        //       replaceUrl: false,
        //       state: this.navigationExtras,
        //     });
        //     res.present();
        //   });
      }
    });
  }

  getPackageBookingBill(val: boolean) {
    this.billDisplay = val;
  }

  getPaymentGateway(countryId?: string, paymentGatewayId?: string) {
    this.makePayment = true;
    let _paymentGateway;
    let _countryId = countryId ? countryId : null;
    this.paymentService
      .getPaymentGateway(_countryId, _paymentGateway)
      .subscribe((pgList: Array<PaymentGatewayInfo>) => {
        if (pgList && pgList.length > 0) this.paymentGatewayList = pgList;
        // if(this.paymentGatewayList && this.paymentGatewayList.length > 0) {
        //     this.paymentBackendURL = this.pay
        // }
      });
  }

  // This method genrate bill and redirect to payment gatway
  async redirectToPaymentPage() {
    let _pgRegion: string;
    let _countryId: string;
    let _type;
    let _collectionId: string = 'q70lo0l_';
    let _paymentGateway = this.selectPaymentMethod.type;
    let userData = JSON.parse(localStorage.getItem('mygolf2uapp.sessionInfo'));
    let paymentDetails: any;
    let _amount = Number(this.requestDetails.stayPlayPackage.basePrice);
    this.paymentRedirectURL = this.selectPaymentMethod.redirect_url;
    let _signature;
    let paymentDetailsPage: any;
    this.paymentInternalURL = this.selectPaymentMethod.internal_payment_url;

    this.paymentBackendURL = this.selectPaymentMethod.callback_url;
    this.paymentRedirectURL = this.selectPaymentMethod.redirect_url;
    this.paymentInternalURL = this.selectPaymentMethod.internal_payment_url;
    this.paymentPageURL =
      this.selectPaymentMethod.http_server + this.selectPaymentMethod.payment_url;
    // this.pgDescription = selectedMethod.description

    let _mygolfServerHost = global.MygolfServerHost;
    if (_mygolfServerHost)
      this.paymentBackendURL = 'http://' + _mygolfServerHost + '/rest/payment/ipay88/backend';
    //'http://devlet.mygolf2u.com/rest/payment/ipay88/backend';
    else this.paymentBackendURL = 'http://devlet.mygolf2u.com/rest/payment/ipay88/backend';
    if (_mygolfServerHost === 'devlet.mygolf2u.com')
      this.paymentRedirectURL = 'http://dev-play.mygolf2u.com/payment_redirect.html';
    //'http://mtest.mygolf2u.com/test/payment_redirect.html';
    else if (_mygolfServerHost === 'azulet.mygolf2u.com')
      this.paymentRedirectURL = 'http://azu-play.mygolf2u.com/payment_redirect.html'; //'http://mtest.mygolf2u.com/test/payment_redirect.html';

    // this.goToPaymentURL = 'dev-play'
    if (_mygolfServerHost === 'devlet.mygolf2u.com' || _mygolfServerHost === 'miglet.mygolf2u.com')
      this.goToPaymentURL = 'app';
    //'http://mtest.mygolf2u.com/test/payment_redirect.html';
    else if (_mygolfServerHost === 'azulet.mygolf2u.com') this.goToPaymentURL = 'azu-play'; //'http://mtest.mygolf2u.com/test/payment_redirect.html';

    let _url =
      this.selectPaymentMethod.type === 'ipay88fpx'
        ? 'http://' + this.goToPaymentURL + '.mygolf2u.com/goToPayment-fpx.html'
        : 'http://' + this.goToPaymentURL + '.mygolf2u.com/goToPayment.html';
    if (this.selectPaymentMethod === 'ipay88fpx')
      _url = 'http://' + this.goToPaymentURL + '.mygolf2u.com/goToPayment-fpx.html';
    else if (
      this.selectPaymentMethod.type !== 'ipay88fpx' &&
      this.requestDetails.stayPlayPackage.partner.address.countryData.id === 'IDN'
    ) {
      _url = this.paymentInternalURL;
    } else {
      _url = 'http://' + this.goToPaymentURL + '.mygolf2u.com/payment/goToPayment.html';
    }

    if (this.selectPaymentMethod.type == 'billplz') {
      paymentDetails = {
        collection_id: 'q70lo0l_',
        amount: _amount.toString(),
        email: 'nikzaki@britesoftcorp.com',
        name: userData.user.name,
        mobile: '60123456789',
        description: 'Full payment for ' + this.requestDetails.stayPlayPackage.packageName,
        currency: this.requestDetails.stayPlayPackage.currency.id,
        redirect_url: this.selectPaymentMethod.redirect_url, //'http://mtest.mygolf2u.com/test/payment_redirect.html',
        bill_type: 'booking',
        bill_type_id: 5274,
        paid_by: userData.playerId,
        // "payer_type": this.fromClub ? 'C' : 'R',
        payer_type: 'R',
        // "payment_type": _paymentType === 'full' ? 'B' : 'D',
        payment_type: 'B',
        payment_gateway: this.selectPaymentMethod.id,
        // "PaymentURL": this.paymentPageURL,
      };
    } else if (_paymentGateway == 'ipay88') {
      paymentDetails = {
        collection_id: 'q70lo0l_',
        amount: _amount.toString(),
        email: 'nikzaki@britesoftcorp.com',
        name: userData.user.name,
        mobile: '60123456789',
        description: 'Full payment for ' + this.requestDetails.stayPlayPackage.packageName,
        currency: this.requestDetails.stayPlayPackage.currency.id,
        callback_url: this.selectPaymentMethod.callback_url, // 'http://devlet.mygolf2u.com/rest/payment/billplz/callback',
        redirect_url: this.selectPaymentMethod.redirect_url, //'http://mtest.mygolf2u.com/test/payment_redirect.html',
        bill_type: 'booking',
        bill_type_id: 5274,
        paid_by: userData.playerId,
        // "payer_type": this.fromClub ? 'C' : 'R',
        payer_type: 'R',
        // "payment_type": _paymentType === 'full' ? 'B' : 'D',
        payment_type: 'B',
        payment_gateway: this.selectPaymentMethod.id,
        // "PaymentURL": this.paymentPageURL,
      };
    }

    _pgRegion = this.selectPaymentMethod.id;
    _countryId = this.selectPaymentMethod.country_id;
    _type = this.selectPaymentMethod.type;
    this.ipay88Details = {
      merchantCode: this.selectPaymentMethod.merchant_code,
      merchantKey: this.selectPaymentMethod.merchant_key,
    };
    // this.ipay88Details.merchantCode = this.selectPaymentMethod.merchant_code;
    // this.ipay88Details.merchantKey = this.selectPaymentMethod.merchant_key;
    this.paymentBackendURL = this.selectPaymentMethod.callback_url;
    this.paymentRedirectURL = this.selectPaymentMethod.redirect_url;
    this.paymentInternalURL = this.selectPaymentMethod.internal_payment_url;
    this.paymentPageURL =
      this.selectPaymentMethod.http_server + this.selectPaymentMethod.payment_url;
    this.pgDescription = this.selectPaymentMethod.description;
    //
    if (
      this.selectPaymentMethod.signature_algorithm &&
      this.selectPaymentMethod.signature_algorithm.length > 0
    )
      this.paymentSignAlgo = this.selectPaymentMethod.signature_algorithm;
    if (
      this.selectPaymentMethod.signature_algorithm &&
      this.selectPaymentMethod.signature_algorithm.length > 0
    )
      this.paymentSignAlgo = this.paymentSignAlgo.replace('-', '');
    _url = this.paymentInternalURL
      ? this.paymentInternalURL
      : this.selectPaymentMethod.internal_payment_url;

    let loder = await this.loadingCtrl.create({
      message: 'Redirecting to payment page...',
      showBackdrop: false,
      duration: 5000,
    });

    loder.present().then(() => {
      this.paymentService
        .createBill(_collectionId, paymentDetails, _paymentGateway)
        .subscribe((data: any) => {
          loder.dismiss().then(() => {
            if (
              _pgRegion.toLowerCase().trim().includes('ipay88-id') &&
              this.pgDescription.toLowerCase().trim().includes('sandbox')
            ) {
              _signature =
                this.ipay88Details.merchantKey +
                this.ipay88Details.merchantCode +
                data.bill.toString() +
                _amount +
                this.requestDetails.stayPlayPackage.currency.id;
            } else if (
              _pgRegion.toLowerCase().trim().includes('ipay88-id') &&
              !this.pgDescription.toLowerCase().trim().includes('sandbox')
            ) {
              _signature =
                this.ipay88Details.merchantKey +
                this.ipay88Details.merchantCode +
                data.bill.toString() +
                _amount +
                this.requestDetails.stayPlayPackage.currency.id;
            } else if (
              _pgRegion.toLowerCase().trim().includes('ipay88') &&
              this.pgDescription.toLowerCase().trim().includes('sandbox')
            ) {
              _signature =
                this.ipay88Details.merchantKey +
                this.ipay88Details.merchantCode +
                data.bill.toString() +
                _amount +
                this.requestDetails.stayPlayPackage.currency.id;
            } else {
              _signature =
                this.ipay88Details.merchantKey +
                this.ipay88Details.merchantCode +
                data.bill +
                _amount +
                this.requestDetails.stayPlayPackage.currency.id;
            }
            // _signature = this.selectPaymentMethod.merchant_key + this.selectPaymentMethod.merchant_code + data.bill.toString() + _amount + this.requestDetails.stayPlayPackage.currency.id;

            let sha256_signature = sha256(_signature);
            paymentDetailsPage = {
              MerchantCode: this.selectPaymentMethod.merchant_code,
              PaymentId: '',
              RefNo: data.bill, //'TestPay88_'+moment().format('HHmmss'),
              Amount: _amount,
              Currency: this.requestDetails.stayPlayPackage.currency.id,
              ProdDesc: 'Packgae booking',
              UserEmail: 'nikzaki@britesoftcorp.com,data.email',
              UserName: userData.user.name,
              UserContact: '',
              Remark: '',
              SignatureType: 'SHA256',
              Signature: sha256_signature,
              ResponseURL: this.paymentRedirectURL,
              BackendURL: this.paymentBackendURL,
              PaymentURL: this.paymentPageURL,
            };

            if (data.url && this.selectPaymentMethod.type == 'billplz') {
              if (this.platform.is('capacitor')) {
                this.openWithInAppBrowser(data.url, null, 'getBill', data);
              } else {
                let win = window.open(data.url, '_system');

                let winTick = setInterval(() => {
                  if (win && win.closed) {
                    clearInterval(winTick);
                    this.getBill(data.id, 'billplz');
                    //
                  }
                }, 500);
              }
            } else if (data && _paymentGateway == 'ipay88') {
              // this.selectPaymentMethod === 'ipay88page' || this.selectPaymentMethod === 'ipay88fpx'

              //

              let _data = data;

              let _amount;
              let _ipayUrl;
              if (this.selectPaymentMethod === 'ipay88fpx')
                _ipayUrl = 'https://dvl3.ipay88.com/epayment/entry.asp';
              else {
                if (this.selectPaymentMethod.id == 'ipay88-my-sb')
                  // _pgRegion === 'ipay88-id'
                  _ipayUrl = this.paymentPageURL;
                else _ipayUrl = 'https://payment.ipay88.com.my/epayment/entry.asp';
              }
              // https://dvl3.ipay88.com/epayment/entry.asp
              this.localBill = _data.bill;

              // let _merchantCode = paymentDetailsPage['MerchantCode'];
              let _MerchantCode = paymentDetailsPage['MerchantCode'];
              let _PaymentId = paymentDetailsPage['PaymentId'];
              let _RefNo = _data.bill; //paymentDetailsPage["RefNo"]
              let _Amount = paymentDetailsPage['Amount'];
              let _Currency = paymentDetailsPage['Currency'];
              let _ProdDesc = paymentDetailsPage['ProdDesc'];
              let _UserName = paymentDetailsPage['UserName'];
              let _UserEmail = paymentDetailsPage['UserEmail'];
              let _UserContact = paymentDetailsPage['UserContact'];
              let _Remark = paymentDetailsPage['Remark'];
              let _SignatureType = paymentDetailsPage['SignatureType'];
              let _Signature = paymentDetailsPage['Signature'];
              let _ResponseURL = paymentDetailsPage['ResponseURL'];
              let _BackendURL = paymentDetailsPage['BackendURL'];

              let _params =
                'MerchantCode=' +
                _MerchantCode +
                '&PaymentId=' +
                _PaymentId +
                '&RefNo=' +
                _RefNo +
                '&Amount=' +
                _Amount +
                '&Currency=' +
                _Currency +
                '&ProdDesc=' +
                _ProdDesc +
                '&UserName=' +
                _UserName +
                '&UserEmail=' +
                _UserEmail +
                '&UserContact=' +
                _UserContact +
                '&Remark=' +
                _Remark +
                '&SignatureType=' +
                _SignatureType +
                '&Signature=' +
                _Signature +
                '&ResponseURL=' +
                _ResponseURL +
                '&BackendURL=' +
                _BackendURL;

              let map;

              var form = document.createElement('form');
              form.target = '_system';
              form.method = 'GET';
              form.action = _url;
              form.style.display = 'none';

              for (var key in paymentDetailsPage) {
                var input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = paymentDetailsPage[key];
                form.appendChild(input);
              }

              let _ipay88Header = `<html>
                    <head>
                    </head>`;

              // http://app.mygolf2u.com/payment/goToPayment.html
              let _ipay88Body =
                `<body >
                    <form id="loginForm" action="` +
                this.paymentInternalURL +
                `" method="post">
                    <span style="font-size:5vw;">Redirecting to payment page ...</span><br>`;

              for (var key in paymentDetailsPage) {
                _ipay88Body +=
                  '<input type="hidden" name="' +
                  key +
                  '" value="' +
                  paymentDetailsPage[key] +
                  '">';
              }

              let _ipay88end = `<script type="text/javascript">
                    setTimeout("document.getElementById('loginForm').submit()", 500);
                    </script>
                    </body>
                    </html>`;

              let _ipay88content = _ipay88Header + _ipay88Body + _ipay88end;
              let _ipay88ContentUrl =
                'data:text/html;base64,' + this.mg2uUtils._btoa(_ipay88content);
              let win;
              let _message = 'This will bring up the payment system.Do you want to proceed?';
              let alert = this.alertCtl
                .create({
                  header: 'Redirecting to payment page',
                  message: _message,
                  cssClass: 'booking-alert',
                  buttons: [
                    {
                      text: 'No',
                      role: 'cancel',
                      handler: () => {
                        //
                      },
                    },
                    {
                      text: 'Yes',
                      handler: () => {
                        if (this.platform.is('capacitor')) {
                          this.openWithInAppBrowser(_ipay88ContentUrl, null, 'getBill', data);
                        } else {
                          win = window.open('', '_system');
                          document.body.appendChild(form);
                          form.submit();
                          document.body.removeChild(form);
                        }

                        let winTick = setInterval(() => {
                          if (win && win.closed) {
                            clearInterval(winTick);
                            this.getBill(data.id, 'ipay88');
                            //
                          }
                        }, 500);
                      },
                    },
                  ],
                })
                .then(res => {
                  res.present();
                });
            }
          });
        });
    });
  }

  //
  selectedPaymentGatway(event: any) {
    if (!event) return;
    let _selectedMethod = event?.detail?.value;
    this.selectPaymentMethod = _selectedMethod;
  }

  public openWithInAppBrowser(url: string, target?: string, attribute?: string, data?: any) {
    let _target;
    if (target) _target = target;
    else _target = '_blank';
    if (this.platform.is('ios')) _target = '_blank';
    let _iab = this.iab.create(url, _target, this.options);

    if (this.platform.is('ios')) {
      _iab.on('loadstart').subscribe(event => {
        let loc = event.url.toLowerCase();
        if (loc.includes(this.paymentRedirectURL.toLowerCase())) {
          setTimeout(function () {
            _iab.close();
          }, 5000);
        }
      });
    } else {
      _iab.on('loadstop').subscribe(event => {
        let loc = event.url.toLowerCase();
        if (loc.includes(this.paymentRedirectURL)) {
          setTimeout(function () {
            _iab.close();
          }, 5000);
        }
      });
    }
  }

  // This method is use to get bill for payment
  public getBill(billId?: string, paymentGateway?: string) {
    //
    this.paymentService.getBill(billId, paymentGateway).subscribe(
      (data: any) => {
        if (
          (data.status && data.paid === 'true' && data.status.toLowerCase() === 'p') ||
          (data.state && data.state.toLowerCase() === 'paid' && paymentGateway === 'billplz')
        ) {
          //   this.toggleRegister = true;

          let alert = this.alertCtl
            .create({
              header: 'Payment successful',
              // subTitle: 'Selected date is '+ _date,
              message:
                'Thank you for the payment.<br>Booking receipt will be sent to you via email.', //'Selected date is ' + '<b>' + _date + '</b>',
              // buttons: ['Close']
              buttons: [
                {
                  text: 'Close',
                  handler: () => {
                    this.navigationExtras.state = {
                      bookings: 2,
                    };
                    this.router.navigate(['package-booking'], {
                      replaceUrl: false,
                      state: this.navigationExtras,
                    });
                    // this.paymentClickedBoolean = false;
                    // this.getBookingItemizedBill();
                    // this.refreshBookingDetails(true);
                  },
                },
              ],
              backdropDismiss: false,
            })
            .then(res => {
              res.present();
            });
          // this.paymentFailed = false;
          // this.paymentDateTime = null;
        } else if (
          (data.status && data.status.toLowerCase() === 'p') ||
          (data.state && data.state.toLowerCase() === '1' && paymentGateway === 'ipay88')
        ) {
          //   this.toggleRegister = true;

          // this.paymentMode = false;
          // this.paymentStatus = 'Paid';
          let alert = this.alertCtl
            .create({
              header: 'Payment successful',
              // subTitle: 'Selected date is '+ _date,
              message:
                'Thank you for the payment.<br>Booking receipt will be sent to you via email.', //'Selected date is ' + '<b>' + _date + '</b>',
              // buttons: ['Close']
              buttons: [
                {
                  text: 'Close',
                  handler: () => {
                    this.navigationExtras.state = {
                      bookings: 2,
                    };
                    this.router.navigate(['package-booking'], {
                      replaceUrl: false,
                      state: this.navigationExtras,
                    });

                    // this.recalculateBookingPricing();
                    // this.paymentAmountType = 'full';
                    // this.getBookingItemizedBill();
                    // this.refreshBookingDetails(true);
                  },
                },
              ],
              backdropDismiss: false,
            })
            .then(res => {
              res.present();
              // this.captchaResponse = null;
            });
          // this.paymentFailed = false;
          // this.paymentDateTime = null;
        } else if (
          (data.state && data.state.toLowerCase() === 'due') ||
          (data.status && data.status.toLowerCase() === 'd')
        ) {
          // this.paymentStatus = 'Due';

          let alert = this.alertCtl
            .create({
              header: 'Payment not successful',
              cssClass: 'delete-booking',
              // subTitle: 'Selected date is '+ _date,
              message:
                'Something went wrong with payment. Please refresh and try again in few minutes.', //'Selected date is ' + '<b>' + _date + '</b>',
              // buttons: ['Close']
              buttons: [
                {
                  text: 'Close',
                  cssClass: 'alertButton',
                  handler: () => {
                    // this.recalculateBookingPricing();
                  },
                },
              ],
              backdropDismiss: false,
            })
            .then(res => {
              res.present();
              // this.captchaResponse = null;
            });
          //   this.refreshBookingDetails();
          //   this.getBookingItemizedBill(false);
          //   this.toggleRegister = false;
        }
        // else if((data.paid && data.paid === 'false' && data.status && data.status.toLowerCase() === 'd')) {
        //     this.paymentStatus = 'Due';
        //     let alert = this.alertCtrl.create({
        //         title: 'Payment not successful',
        //         // subTitle: 'Selected date is '+ _date,
        //         message: 'Something went wrong with payment. Please try again.', //'Selected date is ' + '<b>' + _date + '</b>',
        //         // buttons: ['Close']
        //         buttons: [{
        //             text: 'Close',
        //             handler: () => {
        //             }
        //         }]
        //     });
        //     await alert.present();
        // }
      },
      error => {
        // this.paymentStatus = 'Pending';

        let alert = this.alertCtl
          .create({
            header: 'Payment not successful',
            cssClass: 'delete-booking',
            // subTitle: 'Selected date is '+ _date,
            message:
              'Something went wrong with payment. Please refresh and try again in few minutes.', //'Selected date is ' + '<b>' + _date + '</b>',
            // buttons: ['Close']
            buttons: [
              {
                text: 'Close',
                cssClass: 'alertButton',
                handler: () => {
                  // this.recalculateBookingPricing();
                },
              },
            ],
            backdropDismiss: false,
          })
          .then(res => {
            res.present();
            // this.captchaResponse = null;
          });
        // if (this.enablePaymentTimer) {
        //   this.paymentFailed = true;
        //   this.paymentDateTime = moment();
        // }
        // this.onCancelAssignment();
        //
      }
    );
  }

  // display dropdown from play and stay options
  async presentStayModal() {
    // const modal = await this.modalCtrl.create({
    //   component: HotelSelectionModalComponent,
    //   componentProps: {
    //     stayOptions: this.groupedOptions,
    //     hotelId: this.selectedHotels[0]?.hotelRoom?.id,
    //     // stayOptions: this.packageDetails?.packageStayOptions,
    //     stayId: this.selectedStayOption?.id ?? null,
    //   },
    //   cssClass: 'custom-dropdown',
    //   backdropDismiss: true,
    //   showBackdrop: true,
    // });
    // await modal.present();
    // await modal.onDidDismiss().then(data => {
    //   if (!!data?.data?.selectedOption) {
    //     const selectedData = {
    //       ...data?.data?.selectedOption,
    //       stayNight:
    //         Number(
    //           !!this.packageDetails?.stayDuration?.nights
    //             ? this.packageDetails?.stayDuration?.nights
    //             : data?.data?.selectedOption?.maxNights
    //         ) +
    //         Number(
    //           !!data?.data?.selectedOption.availableForAdditionalNight
    //             ? this.packageDetails?.maxAdditionalNights
    //             : 0
    //         ),
    //     };
    //     // on edit time when user change hotel then delete all rooms
    //     if (this.requestDetails) {
    //       const roomIds = [];
    //       this.selectedHotels.map(room =>
    //         room?.requestRoomId ? roomIds.push(room.requestRoomId) : ''
    //       );
    //       this.selectedAdditionalNight.map(room =>
    //         room?.requestRoomId ? roomIds.push(room.requestRoomId) : ''
    //       );
    //       this.packageService.deleteRequestedRoom(roomIds, this.requestDetails.id).subscribe({
    //         error: err => {
    //           this.errorMessage(err as string);
    //         },
    //       });
    //     }
    //     // reset all stay option fields when hotel changed
    //     this.rooms = [];
    //     this.sharingRoom = [];
    //     this.selectedHotels = [];
    //     this.additionalRooms = [];
    //     this.additionalPlayer = [];
    //     this.additionalPeople = [];
    //     this.addNightSharingRoom = [];
    //     this.selectedAdditionalNight = [];
    //     this.selectedAdditionalDates = [];
    //     this.selectedHotels.push(data?.data?.selectedOption);
    //     // check additional night facility
    //     this.selectedHotels.map(
    //       hotel => (this.isAvailableAdditionalNight = hotel?.availableForAdditionalNight)
    //     );
    //     this.selectedAdditionalNight = [];
    //     this.stayNight = selectedData.stayNight;
    //     this.isShowStayOption = true;
    //     this.packageStayOptionsList = [];
    //   }
    // });
  }
  async addAdditionalNights() {
    // if (this.selectedHotels?.length !== 0 && this.isAvailableAdditionalNight) {
    //   // return unique room which have additional night facility
    //   let uniqueRooms = this.selectedHotels.filter(
    //     (hotel, index, array) =>
    //       array.findIndex(v => v.id === hotel.id && hotel.availableForAdditionalNight) === index
    //   );
    //   const modal = await this.modalCtrl.create({
    //     component: RoomModalComponent,
    //     componentProps: {
    //       hotelDetails: uniqueRooms,
    //     },
    //     cssClass: 'custom-dropdown ',
    //     backdropDismiss: true,
    //     showBackdrop: true,
    //   });
    //   await modal.present();
    //   await modal.onDidDismiss().then(data => {
    //     if (data?.data?.selectedRoom) {
    //       const selectedRoom = JSON.parse(JSON.stringify(data?.data?.selectedRoom));
    //       selectedRoom.requestRoomId = null;
    //       this.selectedAdditionalNight.push(selectedRoom);
    //     }
    //   });
    // } else {
    //   MessageDisplayUtil.showErrorToast(
    //     'Please select a stay option and hotels room',
    //     this.platform,
    //     this.toastCtl,
    //     5000,
    //     'bottom'
    //   );
    // }
  }
  async presentPlayModal(day: number, club?) {
    // const dayIndex = this.dayWiseSelectedClub.findIndex(c => c.date === club.date);
    // const modal = await this.modalCtrl.create({
    //   component: HotelSelectionModalComponent,
    //   componentProps: {
    //     clubCourseInfo: JSON.parse(JSON.stringify(this.clubCourseInfo)),
    //     selectedClub: dayIndex > -1 ? this.dayWiseSelectedClub[dayIndex] : undefined,
    //     selectedDay: day + 1,
    //   },
    //   cssClass: 'custom-dropdown ',
    //   backdropDismiss: true,
    //   showBackdrop: true,
    // });
    // await modal.present();
    // const data = (await modal.onDidDismiss()).data;
    // if (data) {
    //   const index = this.dayWiseSelectedClub.findIndex(day => day.date === club.date);
    //   this.dayWiseSelectedClub[index].selectedClub = JSON.parse(JSON.stringify(data.selectedClub));
    //   this.dayWiseSelectedClub[index].clubCourseInfo = JSON.parse(
    //     JSON.stringify(data.clubCourseInfo)
    //   );
    //   this.dayWiseSelectedClub[index].clubName = JSON.parse(
    //     JSON.stringify(data.selectedClub.club.name)
    //   );
    //   this.dayWiseSelectedClub[index].courseName = JSON.parse(
    //     JSON.stringify(data.selectedClub.course.name)
    //   );
    //   if (this.requestDetails) {
    //     // set payload
    //     const payload = await this.getPayload()?.gameRequests;
    //     // call api to update play option
    //     this.packageService.updateGameRequests(payload, this.requestDetails.id).subscribe({
    //       next: data => {
    //         this.bindPlayOption(data?.requestGames);
    //       },
    //       error: err => {
    //         this.errorMessage(err as string);
    //       },
    //     });
    //   }
    // }
  }

  getClubCourseInfo() {
    this.packageDetails.packagePlayOptions.map(packPlayOps => {
      const existingClubIndex = this.clubCourseInfo.findIndex(
        data => data.clubId === packPlayOps?.club?.id
      );
      // if club already exist then push course in courseInfo array
      if (existingClubIndex > -1) {
        this.clubCourseInfo[existingClubIndex].courseInfo.push({
          courseName: packPlayOps?.course?.name,
          courseId: packPlayOps?.course?.id,
        });
      } else {
        this.clubCourseInfo.push({
          clubName: packPlayOps?.club?.name,
          clubImage: packPlayOps?.club?.clubImage,
          clubId: packPlayOps?.club?.id,
          courseInfo: [
            {
              courseName: packPlayOps?.course?.name,
              courseId: packPlayOps?.course?.id,
            },
          ],
          packagePlayOptionsId: packPlayOps?.id,
        });
      }
    });
  }

  dismissModal() {
    this.modalCtrl.dismiss();
  }

  get isStayNightInvalid() {
    return (
      (!!this.selectedStayOption?.stayNight &&
        this.selectedStayOption?.stayNight > this.maxAvailableNights) ||
      this.selectedStayOption?.stayNight < 0
    );
  }

  get maxAvailableNights() {
    return !!this.selectedStayOption?.maxNights
      ? this.selectedStayOption?.maxNights
      : this.packageDetails?.stayDuration?.nights;
  }

  async preferredDateModal() {
    const calendarOptions: CalendarComponentOptions = {
      from: moment(this.packageDetails.validFrom).startOf('day').toDate(),
      to: moment(this.packageDetails.validUntil).startOf('day').toDate(),
      pickMode: 'range',
    };
    const modal = await this.modalCtrl.create({
      component: DateRangePicker,
      componentProps: {
        selectedDate: this.prefferedDate,
        optionsRange: calendarOptions,
      },
      backdropDismiss: true,
      cssClass: 'dateRange-modal',
      showBackdrop: true,
    });
    await modal.present();

    await modal.onDidDismiss().then(data => {
      if (!!data?.data?.selectedDate) {
        const fromDate = new Date(
          moment(data?.data?.selectedDate?.from).startOf('day').format('YYYY-MM-DD')
        ).getTime();
        const validFrom = new Date(
          moment(this.packageDetails.validFrom).startOf('day').format('YYYY-MM-DD')
        ).getTime();
        const toDate = new Date(
          moment(data?.data?.selectedDate?.to).endOf('day').format('YYYY-MM-DD')
        ).getTime();
        const validUntil = new Date(
          moment(this.packageDetails.validUntil).endOf('day').format('YYYY-MM-DD')
        ).getTime();
        // condition to check selected date is valid or not
        if (fromDate >= validFrom && toDate <= validUntil) {
          this.prefferedDate = data?.data?.selectedDate;
          this.setDateInput(this.prefferedDate);
        } else {
          let alert = this.alertCtl
            .create({
              cssClass: 'my-custom-alert-class delete-booking',
              header: 'Outside from availability',
              backdropDismiss: false,
              message: `The package is available from ${moment(
                this.packageDetails.validFrom
              ).format('DD-MM-YYYY')} to ${moment(this.packageDetails.validUntil).format(
                'DD-MM-YYYY'
              )}. You can't select a date that is outside of package availability.`,
              buttons: [
                {
                  text: 'Ok',
                  role: 'cancel',
                  handler: () => {},
                },
              ],
            })
            .then(res => {
              res.present();
            });
        }
      }
    });
  }

  async additionalNightModal(index) {
    const calendarOptions: CalendarComponentOptions = {
      from: moment(this.packageDetails.validFrom).startOf('day').toDate(),
      to: moment(this.packageDetails.validUntil).startOf('day').toDate(),
      pickMode: 'single',
    };
    const selectedDate = this.selectedAdditionalDates[index]
      ? moment(this.selectedAdditionalDates[index], 'DD-MM-YYYY')
      : new Date();
    const modal = await this.modalCtrl.create({
      component: DateRangePicker,
      componentProps: {
        selectedDate: selectedDate,
        optionsRange: calendarOptions,
      },
      backdropDismiss: true,
      cssClass: 'dateRange-modal',
      showBackdrop: true,
    });
    await modal.present();
    await modal.onDidDismiss().then(data => {
      let date = data?.data?.selectedDate;
      if (date) {
        this.selectedAdditionalDates[index] = moment(date).format('DD-MM-YYYY');
      }
    });
  }

  setDateInput(dates) {
    this.userDetailsForm.controls.preferredDates.setValue(
      [dates.from, dates.to].map((date: Date) => date.toLocaleDateString()).join('-')
    );
  }

  onImageShow(obj: string, index: number, packageIndx: number) {
    this.mainImageSrc[packageIndx] = obj;
    this.imageIndex[packageIndx] = index + 1;
  }

  // Get Image src from particular package
  getImageSrc(index: any) {
    return global.MygolfServer + '/' + index;
  }

  // async onImageClick(index: number) {
  //   const modal = await this.modalCtrl.create({
  //     component: PackageImagePage,
  //     componentProps: {
  //       imageSrc: this.mainImageSrc[index]
  //     }
  //   });
  //   modal.onDidDismiss();
  //   modal.present();
  // }
  // Get Image index from particular package
  getImageIndex(packageIndx: number) {
    return this.imageIndex[packageIndx];
  }

  togglePanel(panel: number) {
    if (panel === 1) {
      this.grpStayOption = !this.grpStayOption;
    } else if (panel === 2) {
      this.grpPlayOption = !this.grpPlayOption;
    } else if (panel === 3) {
      this.grpNearByInfo = !this.grpNearByInfo;
    } else if (panel === 4) {
      this.yourRequest = !this.yourRequest;
    }
  }

  segmentChanged(e: any): void {
    this.activeSegment = e.detail.value;
  }

  socketConnection() {
    let _url = `https://${appProps.chatServer}`;
    this.socket = io(_url); // io('https://bartenderapi.disolutions.net');
    this.socket.on('connect', () => {
      const payload = {
        packageId: this.packageId,
        userId: JSON.parse(localStorage.getItem('mygolf2uapp.sessionInfo')).userId,
        requestId: this.requestDetails?.id,
      };
      this.socket.emit('join', payload);
      this.socket.emit('getChannel', payload);
      this.socket.on('channel', (data: any) => {
        this.isPartnerNewMessages = data?.partnerNewMessages;
      });
    });
  }

  getTravelDates() {
    const dateRangeStr = this.userDetailsForm.controls.preferredDates.value; // Your input date range string
    const dateRangeParts = dateRangeStr.split('-');
    const startDateStr = dateRangeParts[0].trim();
    const endDateStr = dateRangeParts[1].trim();
    const startDateObj = new Date(startDateStr);
    const endDateObj = new Date(endDateStr);
    const formattedStartDate = this.datePipe.transform(startDateObj, 'd MMMM yyyy');
    const formattedEndDate = this.datePipe.transform(endDateObj, 'd MMMM yyyy');
    return `${formattedStartDate} - ${formattedEndDate}`;
  }

  submitRequest() {}

  clickEvent(item: number) {
    if (item === 1) {
      this.activeSegment = 'basicInfo';
    } else if (item === 2) {
      this.activeSegment = 'stayOption';
      const startDate = moment(
        this.userDetailsForm.value.preferredDates.split('-')[0],
        'M/DD/YYYY'
      ).format('YYYY-MM-DD');
      if (!this.requestDetails)
        this.setEffectiveDays(this.packageDetails?.stayDuration?.effectiveDays, startDate);
    } else if (item === 3) {
      this.activeSegment = 'playOption';
    } else if (item === 4) {
      this.activeSegment = 'review';
    } else if (item === 5) {
      this.activeSegment = 'submit';
    }
    this.getEstimatedCharge();
  }

  updateRoomRequest() {
    // set payload
    const payload = this.getPayload().roomRequests;

    // reset stay option fields
    this.sharingRoom = [];
    this.selectedHotels = [];
    this.additionalPlayer = [];
    this.additionalPeople = [];
    this.addNightSharingRoom = [];
    this.selectedAdditionalNight = [];
    this.selectedAdditionalDates = [];

    // call api to update room request
    this.packageService.updateRoomRequests(payload, this.requestDetails.id).subscribe({
      next: data => {
        this.bindStayOption(data?.requestRooms);
        this.getEstimatedCharge();
      },
      error: err => {
        this.errorMessage(err as string);
      },
    });
  }

  checkAdditionalPeoplesValue(people, params, isAdditionalNight, isRoomSharing, room) {
    let totalPlayer = 0;
    if (isAdditionalNight) totalPlayer = +people.detail.value;
    else this.additionalPlayer.map(val => (totalPlayer += +val));

    if (
      +people.detail.value <= +this.userDetailsForm.controls.totalPax.value &&
      totalPlayer <= +this.userDetailsForm.controls.totalPax.value
    ) {
      if (isAdditionalNight) {
        this.additionalPeople[params] = people.detail.value;
        if (isRoomSharing) {
          this.additionalRooms[params] = Math.ceil(
            +this.additionalPeople[params] / +room.hotelRoom.maxOccupancy
          );
        } else {
          this.additionalRooms[params] = +people.detail.value;
        }
      } else {
        this.additionalPlayer[params] = people.detail.value;
        if (isRoomSharing) {
          this.rooms[params] = Math.ceil(
            +this.additionalPlayer[params] / +room.hotelRoom.maxOccupancy
          );
        } else {
          this.rooms[params] = +people.detail.value;
        }
      }
    } else {
      let alert = this.alertCtl
        .create({
          cssClass: 'my-custom-alert-class delete-booking',
          header: 'Number of people exceeds',
          backdropDismiss: false,
          message:
            'Number of people exceeds total number specified. Would you like to increase the number?',
          buttons: [
            {
              text: 'No',
              role: 'cancel',
              handler: () => {
                if (isAdditionalNight) {
                  this.additionalPeople[params] = 0;
                  this.additionalRooms[params] = 0;
                } else {
                  this.additionalPlayer[params] = 0;
                  this.rooms[params] = 0;
                }
              },
            },
            {
              text: 'Yes',
              cssClass: 'alert-button-confirm',
              handler: () => {
                this.userDetailsForm.controls.totalPax.setValue(totalPlayer);
                if (isAdditionalNight) {
                  if (isRoomSharing) {
                    this.additionalRooms[params] = Math.ceil(
                      +this.additionalPeople[params] / +room.hotelRoom.maxOccupancy
                    );
                  } else {
                    this.additionalRooms[params] = +people.detail.value;
                  }
                } else {
                  if (isRoomSharing) {
                    this.rooms[params] = Math.ceil(
                      +this.additionalPlayer[params] / +room.hotelRoom.maxOccupancy
                    );
                  } else {
                    this.rooms[params] = +people.detail.value;
                  }
                }

                MessageDisplayUtil.showMessageToast(
                  'The number of people is updated.',
                  this.platform,
                  this.toastCtl,
                  2000,
                  'bottom'
                );
              },
            },
          ],
        })
        .then(res => {
          res.present();
        });
    }
  }

  sharingChange(event, item, index, isAdditionalNight = false) {
    if (event.detail.checked) {
      if (isAdditionalNight) {
        this.additionalRooms[index] = Math.ceil(
          this.additionalPeople[index] / item.hotelRoom.maxOccupancy
        );
      } else {
        this.rooms[index] = Math.ceil(this.additionalPlayer[index] / item.hotelRoom.maxOccupancy);
      }
    } else {
      if (isAdditionalNight) {
        this.additionalRooms[index] = this.additionalPeople[index];
      } else {
        this.rooms[index] = this.additionalPlayer[index];
      }
    }
  }

  deleteRoom(index: number, isAdditionalNight, room) {
    let alert = this.alertCtl
      .create({
        cssClass: 'my-custom-alert-class delete-booking',
        header: 'Delete room ?',
        backdropDismiss: false,
        message: 'Are you sure to delete this room?',
        buttons: [
          {
            text: 'No',
            role: 'cancel',
            handler: () => {},
          },
          {
            text: 'Yes',
            cssClass: 'alert-button-confirm',
            handler: () => {
              if (room?.requestRoomId) {
                //  reset stay option fields
                this.sharingRoom = [];
                this.selectedHotels = [];
                this.additionalPlayer = [];
                this.additionalPeople = [];
                this.addNightSharingRoom = [];
                this.selectedAdditionalNight = [];
                this.selectedAdditionalDates = [];
                this.packageService
                  .deleteRequestedRoom(room?.requestRoomId, this.requestDetails.id)
                  .subscribe((data: any) => {
                    this.bindStayOption(data?.requestRooms);
                    this.getEstimatedCharge();
                  });
              }
              if (isAdditionalNight) {
                this.additionalRooms.splice(index, 1);
                this.additionalPeople.splice(index, 1);
                this.addNightSharingRoom.splice(index, 1);
                this.selectedAdditionalNight.splice(index, 1);
                this.selectedAdditionalDates.splice(index, 1);
              } else {
                this.rooms.splice(index, 1);
                this.sharingRoom.splice(index, 1);
                this.selectedHotels.splice(index, 1);
                this.additionalPlayer.splice(index, 1);
              }
              // Clear additional night when no hotel is selected
              if (!this.selectedHotels.length) {
                this.additionalRooms = [];
                this.additionalPeople = [];
                this.addNightSharingRoom = [];
                this.selectedAdditionalNight = [];
              }
              this.isAvailableAdditionalNight = this.selectedHotels.some(
                hotel => hotel.availableForAdditionalNight
              );
            },
          },
        ],
      })
      .then(res => {
        res.present();
      });
  }

  deletePlayOption(index: number, game) {
    let alert = this.alertCtl
      .create({
        cssClass: 'my-custom-alert-class delete-booking',
        header: 'Delete play option ?',
        backdropDismiss: false,
        message: 'Are you sure to delete this ?',
        buttons: [
          {
            text: 'No',
            role: 'cancel',
            handler: () => {},
          },
          {
            text: 'Yes',
            cssClass: 'alert-button-confirm',
            handler: () => {
              if (game?.requestGameId) {
                this.packageService
                  .deleteRequestedGame(game?.requestGameId, this.requestDetails?.id)
                  .subscribe({
                    next: (data: any) => {
                      this.bindPlayOption(data?.requestGames);
                      const previousData = this.dayWiseSelectedClub[index];
                      this.dayWiseSelectedClub.splice(index, 1, {
                        day: index + 1,
                        date: previousData.date,
                      });
                      this.getEstimatedCharge();
                    },
                    error: err => {
                      this.errorMessage(err as string);
                    },
                  });
              } else {
                const previousData = this.dayWiseSelectedClub[index];
                this.dayWiseSelectedClub.splice(index, 1, {
                  day: index + 1,
                  date: previousData.date,
                });
              }
            },
          },
        ],
      })
      .then(res => {
        res.present();
      });
  }

  convertDate(selectedAdditionalDates: any, fromFormat?: string, toFormat?: string) {
    let _toFormat = 'DD MMM YYYY';
    let _fromFormat = 'DD-MM-YYYY';
    if (toFormat?.length) _toFormat = toFormat;
    if (fromFormat?.length) _fromFormat = fromFormat;
    return moment(selectedAdditionalDates, fromFormat).format(_toFormat);
  }

  DDMMYYYFormate(date) {
    return moment(date, 'M/DD/YYYY').format('DD-MM-YYYY');
  }
  submitChange(event) {
    this.comments = event.detail.value.trim('');
  }

  async touchEnd(zoomSlides: IonSlides, card: any) {
    // Zoom back to normal
    const slider = await zoomSlides.getSwiper();
    const zoom = slider.zoom;
    zoom.out();

    // Card back to normal
    card.el.style['z-index'] = 9;

    this.zoomActive = false;
    this.changeDetectorRef.detectChanges();
  }

  touchStart(card) {
    // Make card appear above backdrop
    card.el.style['z-index'] = 11;
  }

  async termAndCondition(packageDetails: any) {
    // const modal = await this.modalCtrl.create({
    //   component: TermsAndConditionComponent,
    //   cssClass: this.platform.is('mobile')
    //     ? 'self-adjustable-modal'
    //     : 'self-adjustable-modal-desktop',
    //   componentProps: {
    //     packageDetails: packageDetails,
    //     isFromMyBookingPage: this.isFromMyBookingPage,
    //     requestDetails: this.requestDetails,
    //   },
    //   mode: 'ios',
    // });
    // await modal.present();
  }
  async stayOptionDetail(stayOption: PackageStayOption) {
    // if (this.segmentClicked) {
    //   this.segmentClicked = false;
    //   return;
    // }
    // console.log('stay option details [0] : ', stayOption);
    // console.log('plstayay option details [1] package details : ', this.packageDetails);
    // let _grpStayOptions: Array<PackageStayOption> = [];
    // await this.getGroupedStayOptions(stayOption?.hotel?.id).then(stayOptions => {
    //   console.debug('stay option details [1a] setting grp', stayOptions);
    //   _grpStayOptions = stayOptions;
    // });
    // console.debug('play option details [2] grouped', _grpStayOptions);
    // const modal = await this.modalCtrl.create({
    //   component: StayOptionDetailComponent,
    //   componentProps: {
    //     hotelDetails: stayOption,
    //     groupedStayOptions: _grpStayOptions,
    //     packageDetails: this.packageDetails,
    //     infoOnly: true,
    //   },
    //   mode: 'ios',
    // });
    // await modal.present();
    // modal.onDidDismiss().then(data => {
    //   if (data?.data === 'confirm') {
    //     this.reserveNow();
    //   }
    // });
  }

  async getGroupedStayOptions(hotelId: number) {
    let _groupedStayOptions: Array<PackageStayOption> = [];
    if ((await this.packageDetails?.packageStayOptions?.length) > 0) {
      _groupedStayOptions = await this.packageDetails.packageStayOptions.filter(
        (stayOpts: PackageStayOption) => {
          return stayOpts?.hotel?.id === hotelId;
        }
      );
    }
    return _groupedStayOptions;
  }

  async getGroupedPlayOptions(clubId: number) {
    let _groupedPlayOptions: Array<PackagePlayOption> = [];
    if ((await this.packageDetails?.packagePlayOptions?.length) > 0) {
      _groupedPlayOptions = await this.packageDetails.packagePlayOptions.filter(
        (playOpts: PackagePlayOption) => {
          return playOpts?.club?.id === clubId;
        }
      );
    }
    return _groupedPlayOptions;
  }
  async playOptionDetail(playOption: PackagePlayOption) {
    // if (this.segmentClicked) {
    //   this.segmentClicked = false;
    //   return;
    // }
    // console.log('play option details [0] : ', playOption);
    // console.log('play option details [1] package details : ', this.packageDetails);
    // let _grpPlayOptions: Array<PackagePlayOption> = [];
    // await this.getGroupedPlayOptions(playOption?.club?.id).then(playOptions => {
    //   console.debug('play option details [1a] setting grp', playOptions);
    //   _grpPlayOptions = playOptions;
    // });
    // console.debug('play option details [2] grouped', _grpPlayOptions);
    // const modal = await this.modalCtrl.create({
    //   component: PlayOptionDetailComponent,
    //   componentProps: {
    //     roomDetails: playOption,
    //     groupedPlayOptions: _grpPlayOptions,
    //     packageDetails: this.packageDetails,
    //     infoOnly: true,
    //   },
    //   mode: 'ios',
    // });
    // await modal.present();
    // modal.onDidDismiss().then(data => {
    //   if (data?.data === 'confirm') {
    //     this.reserveNow();
    //   }
    // });
  }

  async reserveNow() {
    // let _enableRequest = this.enableRequest;
    // _enableRequest = this.mg2uUtils.getSpecificAppAttributePage('mainApp')?.enableSnPRequest;
    // console.debug(
    //   'get app attribute',
    //   this.mg2uUtils.getSpecificAppAttributePage('mainApp')?.enableSnPRequest
    // );
    // if (_enableRequest === null) _enableRequest = this.enableRequest;
    // // if(!appProps?.enableStayNPlayRequest && (_enableRequest === null || _enableRequest === undefined || _enableRequest === '' || _enableRequest === 'false')) {
    // if (!_enableRequest) {
    //   // if(!appProps?.enableStayNPlayRequest) {
    //   let _phoneNumber = '+6012-690-8309';
    //   if (this.packageDetails?.club) {
    //     if (this.packageDetails?.club?.address) {
    //       _phoneNumber =
    //         this.packageDetails?.club?.address?.phone2 ||
    //         this.packageDetails?.club?.address?.phone1;
    //       // this.packageDetails?.club?.address?.phoneNumbers?.numbers[2] ||
    //     }
    //   } else if (this.packageDetails?.partner) {
    //     if (this.packageDetails?.partner?.address)
    //       _phoneNumber =
    //         this.packageDetails?.partner?.address?.phone2 ||
    //         this.packageDetails?.partner?.address?.phone1;
    //   }
    //   if (_phoneNumber === null) _phoneNumber = '+6012-690-8309';
    //   let _msg = 'This feature will be coming soon';
    //   _msg = `If interested, please contact us at ${_phoneNumber}`;
    //   MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 5000, 'bottom');
    //   return;
    // }
    // const modal = await this.modalCtrl.create({
    //   component: PackageBookingComponent,
    //   componentProps: {
    //     packageDetails: this.packageDetails,
    //     groupedOptions: this.groupedOptions,
    //     dayWiseSelectedClub: this.dayWiseSelectedClub,
    //     clubCourseInfo: this.clubCourseInfo,
    //     packageRequest: this.packageRequest,
    //     requestId: this.requestId,
    //     stayOptionsRequest: this.stayOptionsRequest,
    //     selectedPlayOptions: this.selectedPlayOptions,
    //     playOptionsRequest: this.playOptionsRequest,
    //     packageId: this.packageId,
    //     socket: this.socket,
    //     userDetailsFormStore: this.userDetailsForm,
    //     selectHotelsSore: this.selectedHotels,
    //     adiditionalPlayerStore: this.additionalPlayer,
    //     sharingRoomStore: this.sharingRoom,
    //     roomsStore: this.rooms,
    //     estimateChargeStore: this.estimatedCharge,
    //     isFromMyBookingPage: this.isFromMyBookingPage,
    //   },
    //   mode: 'ios',
    // });
    // await modal.present();
    // modal.onDidDismiss().then(data => {
    //   if (data?.data) {
    //     this.navigationExtras = {
    //       state: {
    //         bookings: 2,
    //         isPackageBooking: true,
    //       },
    //     };
    //     this.router.navigate(['package-booking'], {
    //       replaceUrl: false,
    //       state: this.navigationExtras,
    //     });
    //   }
    // });
  }

  additionalItem(data: string) {
    const regex = /You can bring wife\/husband\/whoever at no additional cost[^.]*/;
    const match = data.match(regex);
    if (match) {
      return match[0];
    }
  }

  checkIn(data: string) {
    const regex = /Check in Fri, Check out Sun[^.]*/;
    const match = data.match(regex);
    if (match) {
      return match[0];
    }
  }

  nightHotel(data: string) {
    const regex =
      /Inclusive of 2 nights stay in Studio Executive Twin room with breakfast for 2 \(TWO\) at Trinidad Suites[^,]*/;
    const match = data.match(regex);
    if (match) {
      return match[0];
    }
  }

  groupedStayOptions: Array<any> = [];
  setGroupedStayOptions() {
    if (!this.packageDetails) return;
    if (!this.packageDetails?.packageStayOptions) return;
    this.groupedStayOptions = this.mg2uUtils.getUnique(
      this.packageDetails.packageStayOptions,
      'hotel.id'
    );
    console.debug('grouped stay options : ', this.groupedStayOptions);
  }

  groupedPlayOptions: Array<any> = [];
  setGroupedPlayOptions() {
    if (!this.packageDetails) return;
    if (!this.packageDetails?.packagePlayOptions) return;
    this.groupedPlayOptions = this.mg2uUtils.getUnique(
      this.packageDetails.packagePlayOptions,
      'club.id'
    );
    console.debug('grouped play options : ', this.groupedPlayOptions);
  }
  getPackageRounds() {
    let total = 0;
    if (this.packageDetails) {
      total = this.packageDetails?.golfRoundSpec?.eighteenHoleRounds || 0;
      total += this.packageDetails?.golfRoundSpec?.nineHoleRounds || 0;
      // total += this.packageDetails?.maxAdditional18HoleRounds || 0;
      // total += this.packageDetails?.maxAdditional9HoleRounds || 0;
    }

    return total;
  }

  getPackageCityState(packageDetails: StayAndPlayPackage) {
    // console.debug("get package city state", packageDetails, packageDetails?.club, packageDetails?.partner)
    let _cityState = '-';
    if (packageDetails?.club?.address) {
      let _address = [];
      if (packageDetails?.club?.address?.city) _address.push(packageDetails?.club?.address?.city);
      if (packageDetails?.club?.address?.state) _address.push(packageDetails?.club?.address?.state);
      if (_address?.length === 0) _address.push(packageDetails?.club?.address?.countryData?.name);
      _cityState = _address.join(', ');

      // _cityState = packageDetails?.club?.address?.city + ', ' + packageDetails?.club?.address?.state;
      // if(!_cityState) _cityState = packageDetails?.club?.address?.countryData?.name;
    } else if (packageDetails?.partner?.address) {
      let _address = [];
      if (packageDetails?.partner?.address?.city)
        _address.push(packageDetails?.partner?.address?.city);
      if (packageDetails?.partner?.address?.state)
        _address.push(packageDetails?.partner?.address?.state);
      if (_address?.length === 0)
        _address.push(packageDetails?.partner?.address?.countryData?.name);
      _cityState = _address.join(', ');
    }
    return _cityState;
  }

  mergedDayPlayOptions: Array<any> = [];
  getDaywise() {
    console.debug('day wise', this.dayWiseSelectedClub);
    console.debug('day wise grouped', this.dayGroupedPlayOptions);
    console.debug('day wise merged play opts : ', this.mergedDayPlayOptions);

    let mergedPlayOptions = [];
    // this.dayWiseSelectedClub.forEach((day)=>{
    //   // mergedPlayOptions.push(...this.objectValues(this.groupAndMergePlayOptions(this.getDayGames(day.date))));
    //   mergedPlayOptions = this.objectValues(this.groupAndMergePlayOptions(this.getDayGames(day.date)));
    //   console.debug(`${day.day} ${day.date} grouped play options`, mergedPlayOptions);
    // })
  }

  getDayGames(date: string) {
    let _dayGames = [];
    if (!this.dayWiseSelectedClub) return;
    if (!this.requestDetails?.requestGames) return;
    if (this.requestDetails?.requestGames?.length) {
      _dayGames = this.requestDetails.requestGames.filter((game: StayAndPlayCourse) => {
        let _gameDate = moment(game.playingOn, 'YYYY-MM-DD').format('YYYY-MM-DD');
        return _gameDate === date;
      });
    }
    return _dayGames;
  }

  dayGroupedPlayOptions: Array<any> = [];
  constructGroupedPlayOptions() {
    if (!this.dayWiseSelectedClub) return;
    if (!this.requestDetails) return;
    this.dayGroupedPlayOptions = [];
    this.dayWiseSelectedClub.forEach((day, index) => {
      this.dayGroupedPlayOptions.push({
        day: day.day,
        date: day.date,
        playOptions: this.requestDetails?.requestGames?.filter((game: StayAndPlayCourse) => {
          let _gameDate = moment(game.playingOn, 'YYYY-MM-DD').format('YYYY-MM-DD');
          return _gameDate === day.date;
        }),
      });
    });
  }

  // constructGroupedByClubCourse(playOptions: Array<any>) {
  //   playOptions = [{
  //     playOption: {
  //       club: {
  //         id: 1
  //       },
  //       course: {
  //         id: 1
  //       }
  //     },
  //     playingIn: 'AM',
  //     totalRounds: 10
  //     },{
  //       playOption: {
  //         club: {
  //           id: 1
  //         },
  //         course: {
  //           id: 2
  //         }
  //       },
  //       playingIn: 'PM',
  //       totalRounds: 5
  //       },{
  //         playOption: {
  //           club: {
  //             id: 1
  //           },
  //           course: {
  //             id: 1
  //           }
  //         },
  //         playingIn: 'PM',
  //         totalRounds: 3
  //         }]
  // }

  groupAndMergePlayOptions(playOptions: Array<any>): { [key: string]: any } {
    const result: { [key: string]: any } = {};

    for (const option of playOptions) {
      const key = `${
        option.playingOn
      } - ${option.playOption.club.name.trim()}-${option.playOption.course.name.trim()}`;
      if (!result[key]) {
        result[key] = {
          date: option.playingOn,
          club: option.playOption.club,
          course: option.playOption.course,
          playOption: option.playOption,
          playingInRounds: [],
        };
      }

      result[key].playingInRounds.push({
        playingIn: option.playingIn,
        totalRounds: option.totalRounds,
      });
    }

    return result;
  }

  objectValues(obj: any) {
    return Object.values(obj);
  }

  getFilteredMergedPlayOptions(idx: number) {
    let _filtered = [];
    if (this.mergedDayPlayOptions?.length) {
      _filtered = this.mergedDayPlayOptions[idx];
      // _filtered = this.mergedDayPlayOptions.filter((game)=>{
      //   return game.filter((g)=>{
      //     return g.date === date
      //   })
      // })
      _filtered.sort((a, b) => {
        if (a.club.name < b.club.name) return -1;
        else if (a.club.name > b.club.name) return 1;
        else {
          if (a.course.displayOrder < b.course.displayOrder) return -1;
          else if (a.course.displayOrder > b.course.displayOrder) return 1;
          else return 0;
        }
      });
      _filtered.forEach(game => {
        game.playingInRounds.sort((a, b) => {
          if (a.playingIn === 'AM' && b.playingIn === 'PM') return -1;
          else if (a.playingIn === 'PM' && b.playingIn === 'AM') return 1;
          else return 0;
        });
      });
    }
    // console.debug("get filtered merged play options ", _filtered)
    return _filtered;
  }

  getClubCourseImage(game) {
    // console.debug("get club image [0] : ", this.clubMembership)
    if (!game) return 'assets/image/No_Image_Available.jpg';
    let _clubCourseImage = '';
    if (game?.course) _clubCourseImage = game?.course?.courseImage;
    else if (game?.club) _clubCourseImage = game?.club?.clubImage;
    else return 'assets/image/No_Image_Available.jpg';

    // console.debug("get club image [1] : ", _clubImage)
    if (_clubCourseImage?.toLowerCase()?.includes(global.MygolfServerHost?.toLowerCase()))
      return _clubCourseImage;
    else return global.MygolfServer + '/' + _clubCourseImage;
  }

  cancelRequest() {
    if (this.requestDetails?.status?.toLowerCase() === 'draft') {
      this.DeletePackageRequest();
      return;
    } else if (this.requestDetails?.status?.toLowerCase() === 'generated') {
      MessageDisplayUtil.showErrorToast(
        'This request has been Accepted. You cannot cancel this request',
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
    } else if (this.requestDetails?.paymentStatus?.toLowerCase() === 'full') {
      MessageDisplayUtil.showErrorToast(
        'This request has been Paid In Full. You cannot cancel this request',
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
    } else {
      MessageDisplayUtil.showErrorToast(
        'You cannot cancel this request. Please contact the Package owner.',
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
    }

    // let alert = this.alertCtl
    //   .create({
    //     cssClass: 'my-custom-alert-class delete-booking',
    //     header: 'Cancel Request',
    //     backdropDismiss: false,
    //     message: 'Are you sure to cancel this Package Request?',
    //     buttons: [
    //       {
    //         text: 'No',
    //         role: 'cancel',
    //         handler: () => {},
    //       },
    //       {
    //         text: 'Yes',
    //         cssClass: 'alert-button-confirm',
    //         handler: () => {
    //           this._onCancelRequest();
    //         },
    //       },
    //     ],
    //   })
    //   .then((res) => {
    //     res.present();
    //   });
  }

  private _onCancelRequest() {
    // this.packageService
  }

  async openPaymentSelection() {
    // const amountPayable = this.requestDetails?.acceptedPrice || this.requestDetails?.estimatedPrice;
    // const amountPaid = this.requestDetails?.amountPaid;
    // const amountBalance = amountPayable - amountPaid;
    // const pageBillDetails: PageBillDetails = {
    //   title: 'Payment for Package ' + this.packageDetails?.packageName,
    //   currency: this.packageDetails?.currency,
    //   depositAmount: 0,
    //   totalAmount: amountBalance,
    //   allowMine: false,
    //   allowDeposit: true,
    //   callerPage: 'package-details',
    //   partner: this.packageDetails?.partner,
    //   club: this.packageDetails?.club,
    // };
    // let _description = `Payment for Package ${this.packageDetails?.packageName} (SnP ${this.requestDetails.id})`;
    // if (this.requestDetails?.requestReference) {
    //   _description = `Payment for Package ${this.requestDetails?.requestReference}`;
    // }
    // const paymentDetails: PaymentDetails = {
    //   billType: 'stay_and_play', // 'stayNplay',
    //   billTypeId: this.requestDetails?.id,
    //   description: _description,
    //   userName: this.requestDetails?.requesterName,
    //   userEmail: this.requestDetails?.requesterEmail,
    //   userContact: this.requestDetails?.phoneNumber,
    //   paidBy: this.requestDetails?.player?.id,
    // };
    // console.debug('Opening common payment selection - paymentDetails', paymentDetails);
    // console.debug('Opening common payment selection - pageBillDetails', pageBillDetails);
    // const modal = await this.modalCtrl.create({
    //   component: CommonPaymentSelectionPage,
    //   cssClass: 'full-screen-modal',
    //   componentProps: {
    //     paymentDetails: paymentDetails,
    //     pageBillDetails: pageBillDetails,
    //     // fromClub: this.fromClub,
    //     // currSession: this.currSession,
    //     // clubInfo: this.clubInfo,
    //     // teeSlotNew: this.teeSlotNew,
    //     // teeTimeSlotDisplay: this.teeTimeSlotDisplay,
    //     // bookingSlot: this.bookingSlot,
    //     // bookingType: this.bookingType,
    //     disableEWallet: true,
    //     disableClubCredit: true,
    //     disableCTA: true,
    //     modalMode: true,
    //   },
    //   mode: 'ios',
    // });
    // modal.onDidDismiss().then(data => {
    //   console.debug('payment selection dismiss ', data);
    //   if (data?.data) {
    //     if (data?.data?.needRefresh) {
    //       this.dayGroupedPlayOptions = [];
    //       this.getPackageDetails();
    //       // this.onRefreshClick();
    //     }
    //   }
    // });
    // await modal.present().then(() => {
    //   const height = this.platform.height() - 180;
    //   if (document.getElementsByClassName('inner-content')[0]['style'] !== undefined)
    //     document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    // });
  }
  getPaymentStatus() {
    if (!this.requestDetails) return 'Total';
    const paymentStatus = this.requestDetails?.paymentStatus;
    // console.debug('get payment status', paymentStatus);
    if (paymentStatus === 'Full') return 'Paid In Full';
    else if (paymentStatus === 'Partial') return 'Partially Paid';
    else if (paymentStatus === 'Unpaid') return 'Total';
    else return 'Total';
  }

  getPaymentAmount(inNumber?: boolean) {
    if (!this.requestDetails) return 0;
    const _payment = this.requestDetails?.amountPaid ? this.requestDetails?.amountPaid : 0;
    if (inNumber) return Number(_payment.toFixed(2));
    else return this.mg2uUtils.numberWithCommas(Number(_payment.toFixed(2)));
  }

  getBalanceAmount(inNumber: boolean = true) {
    if (!this.requestDetails) return 0;
    let _balanceAmount =
      this.requestDetails?.estimatedPrice -
      this.requestDetails?.amountPaid +
      this.getTotalRefundedAmount();
    // console.debug('get balance amount', _balanceAmount);
    if (inNumber) return Number(_balanceAmount);
    else return _balanceAmount;
  }

  getTotalRefundedAmount() {
    let totalRefund = 0;
    if (this.requestDetails?.refunds?.length) {
      const refunds = this.requestDetails?.refunds;
      totalRefund = refunds
        .map(refund => refund?.refundAmount)
        .reduce((a, b) => {
          return a + b;
        }, 0);
    } //this.requestDetail?.refund
    return totalRefund;
  }

  parseDate(date: string) {
    // 2025-03-26T15:28:46
    return moment(date, 'YYYY-MM-DDTHH:mm:ss').format('ddd, DD MMM YYYY');
  }
  parseTime(time: string) {
    return moment(time, 'YYYY-MM-DDTHH:mm:ss').format('hh:mm A');
  }

  getPaymentPaidBy(payment: any) {
    if (payment?.paymentCapturedByName) return payment?.paymentCapturedByName;
    else if (payment?.paidByName) return payment?.paidByName;
    else return payment?.payingPlayer?.playerName;
  }

  billAdjustmentItems: Array<StayAndPlayAdjustment> = [];
  surchargesAppliedItems: Array<PackageSurchargeApplied> = [];
  expandAdjustmentGroups: boolean = false;
  expandSurchargeGroups: boolean = false;
  getBillDetails(attribute: string) {
    if (!this.requestDetails) return;
    const chargeDetails = this.requestDetails?.chargeDetails;
    const adjustmentDetails = this.requestDetails?.adjustments;
    const surchargeDetails = chargeDetails.surcharges;
    switch (attribute) {
      case 'tax':
        const taxBills = [];
        taxBills.push({
          item: 'Tax',
          rate: null,
          qty: null,
          price: chargeDetails?.taxAmount,
        });
        return taxBills;
      case 'room':
        const roomBills = [];
        const roomTotalCharge = chargeDetails?.roomCharges
          .map((rc: RoomChargeDetails) => {
            return rc?.netCharge;
          })
          .reduce((a: number, b: number) => {
            return a + b;
          }, 0);
        if (chargeDetails?.roomCharges?.length)
          roomBills.push({
            item: 'Room Package(s)',
            rate: null,
            qty: null,
            price: roomTotalCharge,
          });
        return roomBills;
      case 'charges':
        const chargeBill = [];
        if (chargeDetails?.totalSinglePackages > 0) {
          chargeBill.push({
            item: 'Single Room Package',
            rate: chargeDetails?.singlePackagePrice,
            qty: chargeDetails?.totalSinglePackages,
            price: chargeDetails?.singlePackageCharge,
          });
        }
        if (chargeDetails?.totalTwinPackages > 0) {
          chargeBill.push({
            item: 'Twin Room Package',
            rate: chargeDetails?.twinPackagePrice,
            qty: chargeDetails?.totalTwinPackages,
            price: chargeDetails?.twinPackageCharge,
          });
        }
        return chargeBill;
      case 'game':
        const gameBills = [];
        const gameTotalCharge = chargeDetails?.gameCharges
          .map((gc: GameChargeDetails) => {
            if (gc?.totalRounds > 0) return gc?.netCharge;
          })
          .reduce((a: number, b: number) => {
            return a + b;
          }, 0);
        if (chargeDetails?.gameCharges?.length)
          gameBills.push({
            item: 'Game Package(s)',
            rate: null,
            qty: null,
            price: gameTotalCharge,
          });
        return gameBills;
      case 'adjustments':
        const adjustments = [];
        const grossItems = adjustmentDetails.filter((adj: StayAndPlayAdjustment) => {
          return !adj.tax;
        });
        const taxItems = adjustmentDetails.filter((adj: StayAndPlayAdjustment) => {
          return adj.tax;
        });
        const totalGrossAdjustments = adjustmentDetails
          .filter((adj: StayAndPlayAdjustment) => {
            return !adj.tax;
          })
          .map((adj: StayAndPlayAdjustment) => {
            return adj?.adjustmentAmount;
          })
          .reduce((a: number, b: number) => {
            return a + b;
          }, 0);
        const totalTaxAdjustments = adjustmentDetails
          .filter((adj: StayAndPlayAdjustment) => {
            return adj.tax;
          })
          .map((adj: StayAndPlayAdjustment) => {
            return adj?.adjustmentAmount;
          })
          .reduce((a: number, b: number) => {
            return a + b;
          }, 0);
        if (grossItems?.length > 0)
          adjustments.push({
            item: 'Adjustment(s) - Gross',
            rate: null,
            qty: null,
            price: totalGrossAdjustments,
            tax: false,
          });

        if (taxItems?.length > 0)
          adjustments.push({
            item: 'Adjustment(s) - Tax',
            rate: null,
            qty: null,
            price: totalTaxAdjustments,
            tax: true,
          });
        return adjustments;
      case 'adjustmentItems':
        const items = [];
        adjustmentDetails
          ?.sort((a, b) => {
            return a?.sequence - b?.sequence;
          })
          .forEach(adj => {
            let _isTax = adj.tax ? `[Tax]` : '';
            items.push({
              item: _isTax + ' ' + adj.remarks,
              rate: null,
              qty: null,
              price: adj.adjustmentAmount,
              tax: adj.tax,
            });
          });
        return items;
      case 'surcharges':
        const surcharges = [];
        const surchargesTotal = chargeDetails?.surcharges
          .map((sc: PackageSurchargeApplied) => {
            return sc.totalSurcharge;
          })
          .reduce((a: number, b: number) => {
            return a + b;
          }, 0);
        if (chargeDetails?.surcharges?.length)
          surcharges.push({
            item: 'Surcharge Applied',
            rate: null,
            qty: null,
            price: surchargesTotal,
          });
        return surcharges;
      case 'surchargeItems':
        const surchargeItems = [];
        surchargeDetails?.forEach((si: PackageSurchargeApplied) => {
          surchargeItems.push({
            item: si?.surchargeName,
            rate: null,
            qty: null,
            price: si?.totalSurcharge,
            tax: si?.taxAmount,
          });
        });
        return;
    }
  }

  segmentClicked: boolean = false;
  onSegmentChange(event) {
    this.segmentClicked = true;
  }

  async onConfirmRequest() {
    let _message = `To proceed with payment, you need to Confirm this booking.<br><br>
    If there is any changes to the booking, please contact the Package Owner - <b>${this.getPackageOwnerName()}</b>.<br><br>
    Do you want to proceed?`;

    const modal = await this.modalCtrl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        mode: 'positive-confirmation',
        headerTitle: 'Confirm Booking',
        confirmMessage: _message,
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      if (document.getElementsByClassName('inner-content')[0])
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      if (data?.data) {
        this.goConfirmRequest();
      }
    });
  }

  goConfirmRequest() {
    this.flightService.approveStayAndPlay(this.requestDetails?.id).subscribe({
      next: data => {},
      error: error => {},
      complete: () => {
        this.getPackageDetails();
      },
    });
  }

  getPackageOwnerName() {
    const ownerName = this.packageDetails?.club?.name || this.packageDetails?.partner?.name;
    return ownerName;
  }

  @ViewChild('content') private content: IonContent;
  @ViewChild('billsTransactionsElement') private billsTransactionsElement: ElementRef;
  @ViewChild('packageRequestInfoElement') private packageRequestInfoElement: ElementRef;

  // Method 1: Scroll to element using IonContent

  async scrollToBillTrxnElement() {
    const element = this.billsTransactionsElement.nativeElement;
    await this.content.scrollToPoint(0, element?.offsetTop, 500); // 500ms animation
  }
  async scrollToPackageRequestInfoElement() {
    const element = this.packageRequestInfoElement.nativeElement;
    await this.content.scrollToPoint(0, element?.offsetTop, 500); // 500ms animation
  }

  getRefundIssuedBy(refund: RefundInstance) {
    const refundIssuedBy = refund?.refundIssuedBy;
    return refundIssuedBy?.name;
  }

  getRefundedTo(refund: RefundInstance) {
    const refundTo = refund?.playerRefunded;
    return `${refundTo?.playerName} (${refundTo?.id})`;
  }

  getPaymentMethod(payment: StayAndPlayPayment) {
    const paymentInfo = payment;
    if (paymentInfo?.paymentMethodName) return paymentInfo?.paymentMethodName;
    else {
      if (!paymentInfo?.playerAccountTransactionId && paymentInfo?.payingPlayer) {
        return 'Online';
      } else if (!paymentInfo?.playerAccountTransactionId && !paymentInfo?.payingPlayer) {
        return 'Paid to Package Owner';
      } else return 'myGolf2u';
    }
  }

  sortRequestDetails() {
    if (!this.requestDetails) return;
    this.requestDetails?.payments?.sort((a, b) => {
      return b?.id - a?.id;
    });
    this.requestDetails?.payments?.sort((a, b) => {
      return b?.id - a?.id;
    });
  }

  constructBillAdjItems() {
    if (!this.requestDetails) return;
    const items = [];
    if (!this.requestDetails?.adjustments) return items;
    const adjustmentDetails = this.requestDetails?.adjustments;

    adjustmentDetails
      ?.sort((a, b) => {
        return a?.sequence - b?.sequence;
      })
      .forEach((adj, idx) => {
        let _isTax = adj.tax ? `[Tax]` : '';
        let _remarks = adj?.remarks ? adj?.remarks : `Item #${idx + 1}`;
        items.push({
          item: _isTax + ' ' + _remarks,
          rate: null,
          qty: null,
          price: adj.adjustmentAmount,
          tax: adj.tax,
        });
      });
    return items;
  }

  constructSurchargeAppliedItems() {
    if (!this.requestDetails) return;
    const items = [];
    if (!this.requestDetails?.chargeDetails?.surcharges) return items;
    const surchargeDetails = this.requestDetails?.chargeDetails?.surcharges;

    surchargeDetails.forEach((sc, idx) => {
      // let _remarks = sc?.remarks ? adj?.remarks : `Item #${idx + 1}`;
      items.push({
        item: sc?.surchargeName,
        rate: null,
        qty: null,
        price: sc?.totalSurcharge,
        tax: sc?.taxAmount,
      });
    });
    console.debug('constructing surcharge items : ', items, surchargeDetails);
    return items;
  }
  getPaymentReminderText() {
    // let message = '';
    // const depositAmount
    // const currencySymbol = this.packageDetails?.currency?.symbol;
    // if(this.packageDetails?.paymentTerms?.cancelOnDeposit) {
    //   message = `Please make a deposit payment of ${currencySymbol} ${}`
    // }
  }

  getSummaryPaymentReminderText() {
    if (!this.packageDetails?.paymentTerms) return;
    if (!this.requestDetails?.stayPlayPackage?.paymentTerms) return;
    if (
      this.requestDetails?.status === 'CustomerCancelled' ||
      this.requestDetails?.status === 'Rejected' ||
      this.requestDetails?.status === 'Expired'
    )
      return;
    const paymentTerms = this.packageDetails?.paymentTerms;
    const fullAmount = this.requestDetails?.estimatedPrice;
    let _txtAmountPayable = '';
    let _amountPayable = '0';
    let _depositPayable = 0;
    let _hourGracePeriod = 1; //days
    // this.appAttribute && this.appAttribute.bookingCutOffValue
    //   ? this.appAttribute.bookingCutOffValue
    //   : 1; //in hour
    // let _bookingDate = momenthis.bookingSlot.slotAssigned.teeOffDate;
    let _fullPaymentBy = moment(this.requestDetails?.startDate, 'YYYY-MM-DD').subtract(
      paymentTerms?.fullPaymentBefore,
      'days'
    );
    let _depositBy = moment(this.requestDetails?.startDate, 'YYYY-MM-DD').subtract(
      paymentTerms?.depositBefore,
      'days'
    );
    // console.debug('summary payment reminder [0]', _fullPaymentBy, _depositBy);
    let _fullPayByText;
    if (paymentTerms?.depositType === 'Percentage' && paymentTerms?.depositAmount === 100) {
      _fullPayByText = moment(_fullPaymentBy).format('YYYY-MM-DD');
    }

    if (paymentTerms?.cancelOnDepositFailure || paymentTerms?.depositRequired) {
      if (paymentTerms?.depositType === 'Absolute') _depositPayable = paymentTerms?.depositAmount;
      else if (paymentTerms?.depositType === 'Percentage')
        _depositPayable = (paymentTerms?.depositAmount / 100) * fullAmount;
    }

    // console.debug(
    //   'summary payment reminder [2] : ',
    //   _depositPayable,
    //   this.getPaymentAmount(true),
    //   this.getBalanceAmount(true)
    // );
    let _currency = this.packageDetails?.currency?.symbol;

    if (this.getBalanceAmount(true) <= 0) return;
    let _depositText = '';

    // if( (paymentTerms?.depositRequired || paymentTerms?.cancelOnDepositFailure))
    // If deposit required
    // IF payment amount < deposit amount
    // >> show deposit amount
    // ELSE
    // >> show remaining amount
    // else if full payment required

    if (paymentTerms?.cancelOnDepositFailure || paymentTerms?.depositRequired) {
      if (this.getPaymentAmount(true) < _depositPayable) {
        _depositText = 'Deposit Payment';
        _txtAmountPayable =
          'Please make a <b>' +
          _depositText +
          ' of amount ' +
          _currency +
          ' ' +
          this.mg2uUtils.numberWithCommas(_depositPayable.toFixed(2)) +
          '</b>';
        _txtAmountPayable +=
          '<br> by end of <b>' + moment(_depositBy).format('ddd, DD MMM YYYY') + '</b>';
      } else {
        _amountPayable = this.mg2uUtils.numberWithCommas(this.getBalanceAmount()?.toFixed(2));
        _txtAmountPayable =
          'Please make a <b>Payment of remaining  ' + _currency + ' ' + _amountPayable + '</b>';
        _txtAmountPayable +=
          '<br> by end of <b>' + moment(_fullPaymentBy).format('ddd, DD MMM YYYY') + '</b>';
      }
    } else {
      _amountPayable = this.mg2uUtils.numberWithCommas(Number(fullAmount.toFixed(2)));
      _txtAmountPayable =
        'Please make a <b>Full Payment of ' + _currency + ' ' + _amountPayable + '</b>';
      _txtAmountPayable +=
        '<br> by end of <b>' + moment(_fullPaymentBy).format('ddd, DD MMM YYYY') + '</b>';
    }

    // if (_depositPayable > 0 && Number(_depositPayable.toFixed(2)) > this.getBalanceAmount(true)) {
    //   _amountPayable = String(_depositPayable);
    //   if (
    //     (paymentTerms?.depositRequired || paymentTerms?.cancelOnDepositFailure) &&
    //     paymentTerms?.depositType === 'Percentage' &&
    //     paymentTerms?.depositAmount === 100
    //   )
    //     _depositText = 'Payment';
    //   else _depositText = 'Payment';
    //   //   _depositText = 'Full Payment';
    //   // else _depositText = 'Deposit Payment';

    //   _txtAmountPayable =
    //     'Please make a ' +
    //     _depositText +
    //     ' of amount ' +
    //     _currency +
    //     ' ' +
    //     _depositPayable.toFixed(2);
    // }
    // else if (
    //   (paymentTerms?.depositRequired || paymentTerms?.cancelOnDepositFailure) &&
    //   paymentTerms?.depositType === 'Absolute' &&
    //   _depositPayable < this.getPaymentAmount(true)
    // ) {
    //   _depositText = 'Deposit Payment';
    //   _txtAmountPayable =
    //     'Please make a <b>' +
    //     _depositText +
    //     ' of amount ' +
    //     _currency +
    //     ' ' +
    //     _depositPayable.toFixed(2) +
    //     '</b>';
    // } else if (this.getPaymentAmount(true) > 0 && this.getBalanceAmount(true) > 0) {
    //   _amountPayable = this.mg2uUtils.numberWithCommas(this.getBalanceAmount()?.toFixed(2));
    //   _txtAmountPayable =
    //     'Please make a <b>Payment of remaining  ' + _currency + ' ' + _amountPayable + '</b>';
    // } else {
    //   _amountPayable = this.mg2uUtils.numberWithCommas(Number(fullAmount.toFixed(2)));
    //   _txtAmountPayable =
    //     'Please make a <b>Full Payment of ' + _currency + ' ' + _amountPayable + '</b>';
    // }
    // moment(_depositBy).isSameOrAfter(moment(), 'days') &&
    // if (paymentTerms?.cancelOnDepositFailure || paymentTerms?.depositRequired)
    //   _txtAmountPayable +=
    //     '<br> by end of <b>' + moment(_depositBy).format('ddd, DD MMM YYYY') + '</b>';
    // // moment(_fullPaymentBy).isSameOrAfter(moment()) &&
    // else if (paymentTerms?.cancelOnFullPaymentFailure)
    //   _txtAmountPayable +=
    //     '<br> by <b>' + moment(_fullPaymentBy).format('ddd, DD MMM YYYY hh:mm A') + '</b>';
    // else {
    //   _txtAmountPayable +=
    //     '<br> by <b>' + moment(_gracePeriod).format('ddd, DD MMM YYYY hh:mm A') + '</b>';
    // }
    _txtAmountPayable += ' to avoid cancellation';

    return _txtAmountPayable;
  }

  getColorStayPlayStatus(status: string) {
    return `${this.mg2uUtils.getColorStayPlayRequestStatus(status)}`;
  }

  getStayPlayStatus(status: string) {
    let _status = status || 'Booked';
    const _checkStatus = status?.toLowerCase();
    switch (_checkStatus) {
      case 'generated':
        _status = 'Pending';
        break;
    }
    return _status;
  }

  getSpecialInstructions() {
    return this.mg2uUtils.parseHtmlToText(this.requestDetails?.specialInstructions);
  }

  isModalOpen: boolean = false;
  async onClickHotelDetails(hotel) {
    const hotelDetailsModal = await this.modalCtrl.create({
      component: HotelDetailsComponent,
      // cssClass: this.platform.is('mobile')
      //   ? 'self-favorite-adjustable-modal'
      //   : 'self-adjustable-modal-desktop',
      componentProps: {
        hotelDetails: hotel,
        hotelRooms: hotel?.hotelRooms,
        // countryList: this.countryList,
        // countryId: this.inputPlayerTravelForm?.passportCountryId,
        headerTitle: 'View Hotel Details',
      },
      showBackdrop: true,
      mode: 'ios',
    });
    await hotelDetailsModal.present();
    hotelDetailsModal.onDidDismiss().then(data => {
      console.debug('modal dismiss hotel details : ', data);

      this.isModalOpen = false;
      if (data?.data) {
        this.modalCtrl.dismiss();
      }
    });
  }
}
